import { dataListsType } from "../components/featured-posts";

export const detailPageCss1 = `
  .gallery {
    display: flex;
    justify-content: space-between;
    margin-top: 32px;
    padding: 25px 0;
    border-top: 1px solid #f2f4f9;
  }
  .gallery img {
    width: 32%;
    height: auto;
    border-radius: 0.5rem;
    object-fit: cover;
    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.3);
    transition: transform 0.3s ease-in-out, box-shadow 0.3s;
  }
  .gallery img:hover {
    transform: translateY(-8px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  }
`;

export const detailPageCss2 = `
  .gallery {
    display: flex;
    justify-content: space-between;
    margin-top: 32px;
    padding: 25px 0;
    border-top: 1px solid #f2f4f9;
  }
  .gallery img {
    width: 48%;
    height: auto;
    border-radius: 0.5rem;
    object-fit: cover;
    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.3);
    transition: transform 0.3s ease-in-out, box-shadow 0.3s;
  }
  .gallery img:hover {
    transform: translateY(-8px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  }
`;

export const detailPageCss3 = `
  body {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
    color: #5e5e5e;
  }
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 888px;
    padding: 10px 32px 32px;
  }
  h1 {
    font-size: 2.2rem;
    font-weight: bold;
    color: black;
  }
  .image-container {
    width: 100%;
    max-height: 600px;
    display: flex;
    justify-content: center;
    overflow: hidden;
    border-radius: 1rem;
    margin-top: 16px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s;
  }
  .image-container:hover {
    box-shadow: 0 8px 10px rgba(0, 0, 0, 0.15);
  }
  .image-container img {
    width: 100%;
    /* height: auto; */
    max-height: 500px;
    object-fit: cover;
  }
  p {
    margin-top: 16px;
    font-size: 1.1rem;
    font-weight: semi-bold;
    padding: 0 10px;
  }
  h3 {
    margin-top: 32px;
    font-size: 1.3rem;
    font-weight: bold;
    color: black;
  }
`;

export const DataLists: dataListsType[] = [
  {
    id: 1,
    title: "中国書道を発見する",
    urlinform: "DiscoverChineseCalligraphy",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Discover%20Chinese%20Calligraphy/chinese-calligraphy3.webp",
    ],
    tags: [
      "書道の基礎",
      "初心者ガイド",
      "筆の使い方",
      "体験内容",
      "中国伝統美術文字",
    ],
    description:
      "中国書道は、二千年以上にわたって行われてきた古代の芸術形式です。毛筆と墨を使って巧みに漢字を書き、美しく表現力豊かな芸術作品を創り出します。",
    category: "旅行",
    nation: "中國",
    body: `
        <div class="container">
          <div class="content">
            <div class="header">
              <h1>中国書道を発見する</h1>   
              <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Discover%20Chinese%20Calligraphy/3.png"
                  alt="中国書道を発見する"
                />
              </div>
            </div>
            <p class="description">
              中国書道は、二千年以上にわたって行われてきた古代の芸術形式です。 
              毛筆と墨を使って巧みに漢字を書き、美しく表現力豊かな芸術作品を創り出します。この記事では、中国書道の基礎と、この魅力的な趣味を始める方法を探ります。
            </p>
            <h3 class="section-title">中国書道とは？</h3>
            <p class="section-text">
              中国書道は単なる文字の書き方ではありません。視覚芸術と言語を融合した芸術形式です。
              各文字は、世代を超えて受け継がれてきた特定の筆画と技法を用いて、慎重に創られています。文字は、墨を適切に吸収し、書き味を引き立てるように設計された、書道用紙として知られる特殊な紙に書かれます。
            </p>
            <div class="gallery">
              <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Discover%20Chinese%20Calligraphy/1.png"
                alt="中国書道を発見する"
              />
              <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Discover%20Chinese%20Calligraphy/2.png"
                alt="中国書道を発見する"
              />
            </div>
            <h3 class="section-title">必要な道具</h3>
            <p class="section-text">
              中国書道を練習するには、いくつかの必須道具が必要です：<br><br>
              
              筆：筆は書道の主要な道具です。通常、獣毛で作られ、鋭い先端があり、正確な筆画が可能です。<br>
              墨：中国の伝統的な墨は、固形の墨棒で、これをすり潰して水と混ぜることで液体の墨を作ります。また、事前に作られた液体墨を使用することもできます。<br>
              紙：中国書道用紙は、宣紙とも呼ばれ、書道に特化して設計されています。
              吸収性が高く、墨が滑らかに流れるようになっています。<br>
              硯：硯は、墨棒を磨り潰し、水と混ぜて墨を作るために使用されます。
            </p>
            <div class="image-container">
              <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Discover%20Chinese%20Calligraphy/4.png"
                alt="中国書道を発見する"
              />
            </div>
            <h3 class="section-title">基本筆画と技法</h3>
            <p class="section-text">
              完全な文字を書き始める前に、中国書道で使用される基本的な筆画を学ぶことが重要です。
              これらの筆画がすべての文字の基礎を形成します。いくつかの一般的な筆画には、以下のようなものがあります：<br><br>
              横画（ヘン）：左から右への直線。<br>
              縦画（ス）：上から下への直線。<br>
              点（デン）：小さな丸いマーク。<br>
              鉤（ゴウ）：カーブした筆画で、最後に鉤が付きます。<br><br>
              筆画の練習<br>
              これらの筆画を練習するには、書道用紙に簡単な線や形を描くことから始めることができます。
              筆をコントロールし、均一で一貫した筆画を作ることに集中します。慣れてくると、完全な文字を書くことに進むことができます。
            </p>
            <h3 class="section-title">適切な紙の選び方</h3>
            <p class="section-text">
              中国書道に適した紙を選ぶことは、最高の結果を得るために重要です。
              書道用紙、または宣紙は、さまざまな質感と厚さがあります。一部の紙は吸収性が高く、他の紙はより細かいディテールを可能にします。さまざまな種類の紙を試して、自分に最適なものを見つけてください。
            </p>
            <h3 class="section-title">書道の芸術</h3>
            <p class="section-text">
              中国書道は単に文字を書くことではなく、芸術を通じて自己表現することです。
              すべての筆画は、慎重かつ考え抜かれたものでなければならず、あなたの感情と意図を反映しています。練習するうちに、独自のスタイルと技法を身に付け、それぞれの作品をユニークなものにします。
            </p>
            <h3 class="section-title">始め方</h3>
            <p class="section-text">
              中国書道を始めるには、道具を集め、練習に集中できる静かな場所を見つけましょう。
              基本的な筆画と文字から始め、徐々により複雑な作品に取り組んでください。書道は旅であり、それぞれの練習セッションが向上し学ぶ機会であることを忘れないでください。
            </p>
            <p class="footer-text">
              中国書道を練習することで、古代の伝統とつながり、美しい芸術作品を創ることができます。
              初心者でも経験豊富な芸術家でも、この永遠の芸術形式は創造性と自己表現の無限の可能性を提供します。
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 2,
    title: "バリの夜：華やかな夜生活",
    urlinform: "BaliNightsVibrantEveningLife",
    css: `${detailPageCss1}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Bali%20nights%20vibrant%20evening%20life/bali-nights8.webp",
    ],
    tags: [
      "バリのナイトライフ",
      "断崖上のラウンジ",
      "ビーチクラブ",
      "バリのエンターテインメント",
      "おすすめの夜のホットスポット",
    ],
    description:
      "バリは美しいビーチと豊かな文化で知られていますが、夜になるとこの島はさらににぎわいます。ゆったりとした夜を楽しみたい人でも、エキサイティングなナイトアウトを求める人でも、バリにはそれぞれにぴったりの場所があります。",
    category: "旅行",
    nation: "インドネシア",
    body: `
        <div class="container">
          <div class="content">
            <div class="header">
              <h1>バリの夜：華やかな夜生活</h1>
              <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Bali%20nights%20vibrant%20evening%20life/4.png",
                  alt="バリの夜：華やかな夜生活"
                />
              </div>
            <p class="description">
              バリは美しいビーチと豊かな文化で知られていますが、夜になるとこの島はさらににぎわいます。ゆったりとした夜を楽しみたい人でも、エキサイティングなナイトアウトを求める人でも、バリにはそれぞれにぴったりの場所があります。ここでは、バリのナイトライフ体験を最大限に楽しむためのトップスポットとヒントを紹介します。
            </p>
            <h3 class="section-title">セミニャク：バリのナイトライフの中心</h3>
            <p class="section-text">
                セミニャクは、バリ島で最も人気のあるナイトライフエリアの一つです。ここには、高級バー、ビーチクラブ、そして活気あるナイトクラブが立ち並んでいます。<br><br>
                クデタ（Ku De Ta）<br>
                クデタは、バリで最も有名なビーチクラブの一つです。見事な海の景色、美味しいカクテル、そして賑やかな雰囲気が魅力的で、必見のスポットです。このクラブではしばしばテーマパーティや国際的なDJが出演し、地元の人々だけでなく観光客にも人気です。<br><br>
                モテルメキシコーラ（Motel Mexicola）<br>
                モテルメキシコーラは、メキシコ料理とお祭りのような雰囲気を独特な形で融合させたスポットです。カラフルな装飾と活気ある音楽が、夕方を楽しむのに最適な場所を演出しています。タコスとマルガリータを試すのを忘れないでください！
            </p>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Bali%20nights%20vibrant%20evening%20life/2.png",
                  alt="バリの夜：華やかな夜生活"
                />
              </div>
            <h3 class="section-title">クタ：パーティー愛好家のためのエリア</h3>
            <p class="section-text">
                クタはにぎやかなナイトライフで知られており、パーティーを楽しみたい人に最適です。このエリアには、深夜まで営業するバー、クラブ、エンターテインメント施設がたくさんあります。<br>
                スカイガーデン（Sky Garden）<br><br>
                スカイガーデンは複数のフロアがあるナイトクラブで、各フロアには異なる音楽ジャンルが用意されています。ハッピーアワー中の食べ放題ビュッフェと飲み放題が有名です。屋上からは街の素敵な景色が楽しめ、全体的な体験をさらに豊かにします。<br><br>
                バウンティディスコテック（Bounty Discotheque）<br>
                バウンティディスコテックは、クタで有名なパーティースポットです。海賊船をテーマにしたデザインとエネルギッシュなダンスフロアがあり、リラックスして夜を楽しむのに最適な場所です。
            </p>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Bali%20nights%20vibrant%20evening%20life/3.png",
                  alt="バリの夜：華やかな夜生活"
                />
              </div>
            <h3 class="section-title">ウルワトゥ：景色が絶景で落ち着いた雰囲気</h3>
            <p class="section-text">
                もっとゆったりとした夜を求める人には、ウルワトゥには見事な断崖上のバーやラウンジがあります。<br><br>
                シングルフィン（Single Fin）<br>
                シングルフィンは断崖の上に位置し、息をのむような海の景色を提供します。冷たい飲み物を楽しみながら夕日を見るのに人気のスポットです。雰囲気はのんびりとしており、落ち着いた夕方を過ごすのに最適です。<br><br>
                ロックバー（Rock Bar）<br>
                アヤナリゾート内にあるロックバーは、独特な設置場所で有名です。このバーは自然の岩の上に建てられており、下から押し寄せる波を間近で見ることができます。少し値段が高いですが、景色と雰囲気はそれだけの価値があります。
            </p>
            <h3 class="section-title">バリのナイトライフを楽しむための実用的なヒント</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Bali%20nights%20vibrant%20evening%20life/1.png",
                  alt="バリの夜：華やかな夜生活"
                />
              </div>
            <p class="section-text">
                - 服装コード：バリのほとんどの場所はカジュアルな服装コードですが、一部の高級ヴェニューではスマートカジュアルな服装が求められる場合があります。<br>
                - 費用：飲み物や入場料はさまざまですが、セミニャクやウルワトゥなどの人気エリアではもっと高くなることが予想されます。<br>
                - 安全：いつも自分の持ち物を注意深く見守り、知らない人からの飲み物を受け取る際には注意してください。<br>
            </p>
            <p class="footer-text">
              バリのナイトライフは多様で活気に溢れており、誰にでも楽しめるものがあります。海の景色が楽しめるビーチクラブからエネルギッシュなナイトクラブまで、あなたの気分に合った完璧なスポットを見つけることができます。では、バリ島の賑やかな夜生活を探索し、忘れられない思い出を作りましょう。
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 3,
    title: "バティック、工芸品、そしてお土産",
    urlinform: "BatikCraftsandSouvenirs",
    css: `${detailPageCss1}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Batik,%20Crafts,%20and%20Souvenirs/crafts3.webp",
    ],
    tags: [
      "バティックアート",
      "インドネシアのお土産",
      "工芸体験",
      "手作り工芸品",
      "おすすめのアクティビティ",
    ],
    description:
      "バティックは、インドネシア文化に深いルーツを持つ美しく独特な織物デザインの芸術です。インドネシアを訪れる旅行者であれ、緻密な工芸品を愛でる人であれ、バティックは記憶に残る有意義な体験と商品を数多く提供します。",
    category: "旅行",
    nation: "インドネシア",
    body: `
        <div class="container">
          <div class="content">
            <div class="header">
              <h1>バティック、工芸品、そしてお土産</h1>
              <div class="gallery">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Batik,%20Crafts,%20and%20Souvenirs/3.png"
                  alt="バティック、工芸品、そしてお土産"
                />
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Batik,%20Crafts,%20and%20Souvenirs/4.png"
                  alt="バティック、工芸品、そしてお土産"
                />
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Batik,%20Crafts,%20and%20Souvenirs/2.png"
                  alt="バティック、工芸品、そしてお土産"
                />
              </div>
            <p class="description">
                バティックは、インドネシア文化に深いルーツを持つ美しく独特な織物デザインの芸術です。インドネシアを訪れる旅行者であれ、緻密な工芸品を愛でる人であれ、バティックは記憶に残る有意義な体験と商品を数多く提供します。この記事では、バティック工芸品とお土産の世界を探索し、旅行者がインドネシアで体験できるアクティビティを紹介します。
            </p>
            <h3 class="section-title">バティックとは？</h3>
            <p class="section-text">
                バティックは、蝋を用いた防染技法によって布地に染色する伝統的な織物芸術です。この技法により、職人は繊細なパターンと鮮やかなデザインを布地に施すことができます。バティックのデザインには、花柄、幾何学模様、動物柄などがよく用いられ、それぞれが独自の文化的意味を持っています。バティック制作は労力を要し、高度な技術が必要であり、それぞれの作品がユニークな芸術作品となっています。
            </p>
            <h3 class="section-title">人気のバティック商品</h3>
            <p class="section-text">
                バティック衣料<br>
                バティックを思い浮かべたとき、最初に頭に浮かぶのはおそらく衣料でしょう。バティックのシャツ、ドレス、サロングは、地元の人々だけでなく観光客にも人気の選択肢です。これらの衣服はスタイルが良いだけでなく快適であり、インドネシアの熱帯性気候にぴったりです。さらに、バティックを着ることは、インドネシア文化を称える素敵な方法でもあります。<br><br> 
                ホームデコレーション<br>
                バティックは着るだけでなく、自宅にインドネシア芸術の雰囲気を演出する素敵な方法でもあります。バティックのテーブルクロス、枕カバー、壁掛けは、鮮やかな色彩と緻密な模様でどんな空間も明るく演出します。これらのアイテムは素敵なお土産や贈り物になり、インドネシアの一部を自宅に持ち帰ることができます。  
            </p>
            <h3 class="section-title">実践的な体験</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Batik,%20Crafts,%20and%20Souvenirs/1.png"
                  alt="バティック、工芸品、そしてお土産"
                />
            </div>
            <p class="section-text">
                バティックワークショップ<br>
                バティックの世界に深く浸りたい人にとって、バティックワークショップへの参加は必見です。多くの地元の職人が、バティック制作の基本を学べるクラスを提供しています。蝋の塗り方から布地の染色まで、これらのワークショップは忘れられない実践的な体験を提供します。また、自分だけのオリジナルお土産を作る素敵な機会にもなります。<br><br>
                バティック市場<br>
                地元の市場を探索することは、さまざまなバティック工芸品やお土産を体験する最良の方法の一つです。ヨガヤカルタのパサル·ベリンガルジョやソロのパサル·クレウェルなどの市場では、衣料からホームデコレーションまで、幅広いバティック商品が取り扱われています。これらの市場を散策することで、バティックデザインの多様性を目の当たりにでき、お得な価格交渉のチャンスもあります！ 
            </p>
            <h3 class="section-title">なぜバティックを選ぶのか？</h3>
            <p class="section-text">
                バティック商品や体験を選ぶことは、旅行をより豊かなものにするだけでなく、地元の職人を支援し、伝統的な工芸を生き続けさせることにもつながります。それぞれのバティック作品は物語を語り、インドネシアの豊かな文化遺産を反映しています。バティックを購入することで、この美しい芸術形式の保存に貢献することができます。
            </p>
            <p class="footer-text">
              独特な衣料品、美しいホームデコレーション、または手作りの工芸体験を探しているかどうかに関わらず、バティックにはあなたにぴったりのものがあります。ですから、次回インドネシアを訪れる際には、バティックアート、工芸品、そしてお土産の世界を探索することをお忘れなく。
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 4,
    title: "多様性と伝統を祝う",
    urlinform: "CelebratingDiversityandTradition",
    css: `${detailPageCss1}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Celebrating%20Diversity%20and%20Tradition/celebrating1.webp",
    ],
    tags: [
      "インドネシアの宗教行事",
      "文化旅行",
      "島の祭り",
      "インドネシアの伝統",
      "インドネシアの伝統儀式",
    ],
    description:
      "文化と遺産に富むインドネシアは、その多様性と伝統を祝う数え切れないほどの機会を提供します。数千の島々と多数の民族が存在するインドネシアは、世界中の訪問者を魅了する活気に満ちた祭りと習俗の織り交ぜを見せます。",
    category: "旅行",
    nation: "インドネシア",
    body: `
        <div class="container">
          <div class="content">
            <div class="header">
              <h1>多様性と伝統を祝う</h1>
            <p class="description">
                文化と遺産に富むインドネシアは、その多様性と伝統を祝う数え切れないほどの機会を提供します。数千の島々と多数の民族が存在するインドネシアは、世界中の訪問者を魅了する活気に満ちた祭りと習俗の織り交ぜを見せます。祭りに参加できる旅行者のホットスポットを探しているなら、インドネシアはあなたのリストのトップにあるべきです。ここでは、訪問中に参加できるいくつかの重要な伝統と祭りを紹介します。
            </p>
            <h3 class="section-title">バリのニェピ祭り</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Celebrating%20Diversity%20and%20Tradition/1.png"
                  alt="多様性と伝統を祝う"
                />
              </div>
            <p class="section-text">
                ニェピは、「沈黙の日」とも呼ばれ、バリのヒンズー教の独特な祝祭で、バリの新年の始まりを迎えます。他の新年祝祭とは異なり、ニェピは24時間の沈黙、断食、瞑想で迎えられます。ニェピの前日には、地元の人々が活気に満ちたオゴーオゴーパレードに参加し、巨大な悪魔の像が道を練り歩き、邪悪な霊を追い払います。訪問者はこのパレードを目撃し、ニェピの静かな雰囲気を体験することができます。
            </p>
            <h3 class="section-title">ジャワのヨガヤカルタ芸術祭</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Celebrating%20Diversity%20and%20Tradition/2.png"
                  alt="多様性と伝統を祝う"
                />
              </div>
            <p class="section-text">
                毎年ジャワで開催されるヨガヤカルタ芸術祭は、1ヶ月間にわたる芸術と文化の祭典です。この祭りでは、伝統的なジャワ舞踊、音楽、演劇に加え、現代美術展やパフォーマンスが披露されます。旅行者がジャワの豊かな芸術遺産に浸り、地元の芸術家やパフォーマーと交流する絶好の機会です。祭りにはワークショップや文化ツアーも含まれており、芸術愛好家にとって必見のイベントです。
            </p>
            <h3 class="section-title">トラジャの葬儀</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Celebrating%20Diversity%20and%20Tradition/3.png"
                  alt="多様性と伝統を祝う"
                />
              </div>
            <p class="section-text">
                スラウェシのトラジャ族は、精巧な葬儀式で知られており、これはインドネシアで最も重要な文化行事の一つとされています。これらの儀式は数日間続くことがあり、伝統的な舞踊、音楽、動物犠牲が含まれます。外部の人には珍しいように見えるかもしれませんが、これらの儀式はトラジャ族が故人を称え、来世への円滑な移行を確保するための方法です。訪問者は礼儀正しく儀式を観察し、トラジャ族の独特な信念と習俗を学ぶことができます。
            </p>
            <h3 class="section-title">ロンボックのバウ·ニャレ祭</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Celebrating%20Diversity%20and%20Tradition/4.png"
                  alt="多様性と伝統を祝う"
                />
              </div>
            <p class="section-text">
                ロンボック島で開催されるバウ·ニャレ祭は、神話、伝統、コミュニティ精神を融合した魅力的なイベントです。この祭りは、望まない結婚から逃れるために海のミミズ（ニャレ）に変身したマンダリカ姫の伝説を中心に展開されます。毎年、地元の人々と訪問者がビーチに集まり、幸運と繁栄をもたらすと信じられているニャレを捕まえます。祭りには伝統的な音楽、舞踊、食べ物も登場し、誰にとっても活気に満ちた魅力的な体験となります。
            </p>
            <h3 class="section-title">スマトラのタブイク祭</h3>
            <p class="section-text">
                西スマトラで祝われるタブイク祭は、イスラムの祝祭アシューラを記念するものです。この祭りでは、イスラム史上重要な人物であるイマーム·フセインの葬儀を象徴する大きなカラフルな仮面（タブイク）が制作され、パレードされます。イベントは、仮面を海に投げ込むことで終わり、それに伴って伝統的な音楽と舞踊が行われます。旅行者はこの祝祭に参加し、このイベントの深い宗教的および文化的意義を目の当たりにすることができます。
            </p>
            <p class="footer-text">
                インドネシアの多様な伝統と祭りは、この国の豊かな文化の一端を垣間見る貴重な機会を提供します。ニェピの静かな反省からバウ·ニャレ祭の活気ある祝祭まで、旅行者が地元の習俗と伝統に浸る方法は数多くあります。ですから、忘れられない文化体験を求めているなら、インドネシアは完璧な目的地です。<br><br>
                これらの祭りに参加することで、訪問者は地元の人々と共に祝うだけでなく、インドネシアの文化的多様性に対する深い理解を得ることができます。次回の旅行でこれらの特別なイベントの一部になるチャンスを逃さないでください。
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 5,
    title: "中国の祭り：文化と遺産",
    urlinform: "ChinasFestivalsCultureandHeritage",
    css: `${detailPageCss1}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/China%E2%80%99s%20Festivals%20Culture%20and%20Heritage/china-festivals1.webp",
    ],
    tags: [
      "文化の伝統",
      "祭りの食べ物",
      "祭り",
      "遺産の祝祭",
      "中国の文化遺産行事",
    ],
    description:
      "中国は歴史、文化、伝統に富む国であり、その祭りはこの活気に満ちた文化遺産の証です。カラフルなパレードから美味しい祭りの食べ物まで、これらのイベントは中国の習俗と信念を垣間見る貴重な機会を提供します。",
    category: "旅行",
    nation: "中國",
    body: `
        <div class="container">
          <div class="content">
            <div class="header">
              <h1>中国の祭り：文化と遺産</h1>
            <p class="description">
                中国は歴史、文化、伝統に富む国であり、その祭りはこの活気に満ちた文化遺産の証です。カラフルなパレードから美味しい祭りの食べ物まで、これらのイベントは中国の習俗と信念を垣間見る貴重な機会を提供します。旅行者にとって、これらの祭りを理解することは旅行をさらに充実させ、忘れられない体験を提供するでしょう。以下に、中国で最も盛大に祝われる祭りのいくつかと、期待できることに関するヒントを紹介します。
            </p>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/China%E2%80%99s%20Festivals%20Culture%20and%20Heritage/1.png"
                  alt="中国の祭り：文化と遺産"
                />
              </div>
            <h3 class="section-title">中国の新年</h3>
            <p class="section-text">
                中国の新年は、春節とも呼ばれ、中国で最も重要な祭りです。通常は1月下旬から2月上旬にかけて祝われます。家族が集まり、餃子、魚、年糕などの料理が並ぶご馳走で祝います。赤い飾りは幸運を象徴し、至る所で見られます。この祭りは家族や地域コミュニティによって企画されており、深く個人的で共同体的なイベントとなっています。
            </p>
            <h3 class="section-title">元宵節</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/China%E2%80%99s%20Festivals%20Culture%20and%20Heritage/4.png"
                  alt="中国の祭り：文化と遺産"
                />
              </div>
            <p class="section-text">
                旧正月15日に行われる元宵節は、中国の新年祝祭の終わりを告げる祭りです。人々は色とりどりの提灯を灯し、展示します。提灯にはしばしば謎が書かれています。この祭りの伝統的な食べ物は、甘い餅のようなタンユエンです。地元の文化団体やコミュニティセンターが提灯の展示やその他のイベントを主催することが多いです。
            </p>
            <h3 class="section-title">端午節</h3>
            <p class="section-text">
                旧暦5月5日に行われる端午節は、古代の詩人屈原を偲ぶ祭りです。伝統的なドラゴンボートレースがハイライトで、チームが細長いボートを漕いでスリリングな競争を繰り広げます。この時期には、竹の葉に包まれたモチ米のゾンジなどの祭りの食べ物が人気です。この祭りはしばしば地元のスポーツクラブや文化団体によって主催されます。
            </p>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/China%E2%80%99s%20Festivals%20Culture%20and%20Heritage/2.png"
                  alt="中国の祭り：文化と遺産"
                />
            </div>
            <h3 class="section-title">中秋節</h3>
            <p class="section-text">
                中秋節は旧暦8月15日に祝われます。満月を楽しみ、蓮の種のペーストや小豆のペーストが詰まった甘いムーンケーキを味わう季節です。家族が集まりこれらのお菓子を分かち合い、提灯が灯されて団結と繁栄を象徴します。地元の政府やコミュニティグループが提灯祭りやその他のイベントを開催してこの節目を祝うことが多いです。
            </p>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/China%E2%80%99s%20Festivals%20Culture%20and%20Heritage/3.png"
                  alt="中国の祭り：文化と遺産"
                />
            </div>
            <h3 class="section-title">清明節</h3>
            <p class="section-text">
                清明節は、墓参りの日とも呼ばれ、4月4日または5日頃に行われます。この時期は、先祖の墓を訪れ、墓碑を清掃し、食べ物や線香を供えることで先祖を偲ぶ季節です。この祭りは祝祭よりもむしろ追悼と敬意を表すものです。主に家族によって行われますが、一部の地方政府が公共の追悼式を開催することもあります。
            </p>
            <h3 class="section-title">中国の祭りへの旅行者ガイド</h3>
            <p class="section-text">
                中国への旅行を計画する際には、これらの祭りと重なる時期に訪れることを検討してください。現地の文化を直接体験できるだけでなく、独特の伝統や祭りの食べ物に参加する機会も得られます。事前に調べて、どの団体が祭りを主催しているか、計画されている具体的なイベントがあるかを確認してください。<br><br>
                これらの祭りを理解し、参加することで、中国の豊かな文化遺産に対する理解が深まります。ドラゴンボートレースを見物したり、満月の下でムーンケーキを味わったりするなど、これらの体験は確かにあなたの旅行を豊かにするでしょう。
            </p>
            <p class="footer-text">
              これらの祭りに参加したことがありますか？まだなら、ぜひ試してみてください！
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 6,
    title: "中国の自然景観を発見する",
    urlinform: "DiscoverChinasNaturalLandscapes",
    css: `${detailPageCss1}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Discover%20China%27s%20Natural%20Landscapes/natural-nandscapes1.webp",
    ],
    tags: [
      "中国を探索",
      "ハイキングアドベンチャー",
      "アウトドア活動",
      "自然の驚異",
      "景色の美しい旅行",
    ],
    description:
      "中国は息をのむほどの美しさと多様な自然景観が広がる国です。そびえ立つ山々から静かな川まで、探索する価値のあるものがたくさんあります。",
    category: "旅行",
    nation: "中國",
    body: `
       <div class="container">
          <div class="content">
            <div class="header">
              <h1>中国の自然景観を発見する</h1>
            <p class="description">
                中国は息をのむほどの美しさと多様な自然景観が広がる国です。そびえ立つ山々から静かな川まで、探索する価値のあるものがたくさんあります。熱心なハイカーであれ、自然愛好家であれ、自然の中で静かな時間を楽しむ人であれ、中国の自然景観は誰にでも何かを提供します。この記事では、訪れることができる最も壮観なスポットのいくつかを紹介し、ルートや到着後のアクティビティに関するヒントも提供します。
            </p>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Discover%20China%27s%20Natural%20Landscapes/1.png"
                  alt="中国の自然景観を発見する"
                />
              </div>
            <h3 class="section-title">張家界国家森林公園</h3>
            <p class="section-text">
                張家界国家森林公園は、そびえ立つ砂岩の柱で有名です。これらの独特な地形は、映画「アバター」の浮遊山をインスパイアしました。公園内をさまざまなハイキングコースで探索することができ、壮観な景色を楽しむことができます。よりスリリングな体験を求めるなら、深い峡谷を横切るガラス橋を歩いてみてください。この公園は、劇的な景観が好きな人には必見です。
            </p>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Discover%20China%27s%20Natural%20Landscapes/2.png"
                  alt="中国の自然景観を発見する"
                />
              </div>
            <h3 class="section-title">九寨溝</h3>
            <p class="section-text">
                九寨溝は、中国の自然の宝庫の一つです。このユネスコの世界遺産は、色鮮やかな湖、滝、雪を被った山々で知られています。谷内は徒歩で探索するのが最適で、鮮やかな色彩と自然の美しさを間近に感じることができます。五色湖を訪れるのを忘れないでください。この湖は多彩な色の水で有名です。
            </p>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Discover%20China%27s%20Natural%20Landscapes/3.png"
                  alt="中国の自然景観を発見する"
                />
              </div>
            <h3 class="section-title">黄山（黄色の山）</h3>
            <p class="section-text">
                黄山は、ハイカーや写真家にとっての楽園です。この山は「四大奇観」で有名です。壮観な日の出、雲海、奇岩、そして曲がった松の木です。訪問を最大限に楽しむために、山のホテルで一夜過ごすことを検討してください。これにより、壮観な日の出を見ることができ、日中の混雑を避けることができます。
            </p>
            <h3 class="section-title">リー川</h3>
            <p class="section-text">
                リー川は、透き通った水と劇的なカルスト地形の山々が見事な景観を演出します。リー川を体験する最良の方法の一つは、桂林からヤンシュオまでのボートクルーズです。クルーズでは息をのむほどの景色と数多くの写真撮影のチャンスが得られます。よりアクティブなアドベンチャーを求めるなら、ヤンシュオで自転車を借りて田園地帯を探索するのもおすすめです。
            </p>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Discover%20China%27s%20Natural%20Landscapes/4.png"
                  alt="中国の自然景観を発見する"
                />
              </div>
            <h3 class="section-title">チベットのエベレスト基地</h3>
            <p class="section-text">
                よりチャレンジングなアドベンチャーを求める人にとって、チベットのエベレスト基地は究極の目的地です。基地までの旅は困難ですが、その報酬は価値があります。世界最高峰の直近の景色を楽しみ、チベットの独特な文化を体験することができます。高高度に適応するために十分な準備をし、必要な予防策を講じてください。
            </p>
            <h3 class="section-title">ルートと旅行のヒント</h3>
            <p class="section-text">
                中国の自然景観を訪れる旅行を計画する際には、最良のルートと旅行のヒントを調べることが重要です。これらの場所の多くは、特にチベットのような敏感な地域では許可が必要です。<br><br>
                これらの人気スポットはすぐに満室になる可能性があるため、事前に宿泊施設を予約するようにしてください。最後に、常に自然環境を尊重し、これらの美しい景観が将来の世代にも素敵なまま残るように、地元のガイドラインに従ってください。
            </p>
            <p class="footer-text">
                要するに、中国の自然景観は幅広いアクティビティと壮観な景色を提供します。ハイキング、ボート遊び、または単に美しさを楽しむことを好む人にも、誰にでも楽しめるものがあります。ですから、荷物を詰めて、世界で最も美しい国の一つで冒険を始めましょう。
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 7,
    title: "日本のショッピングシーンのトレンドを発見する",
    urlinform: "DiscovertheTrendsinJapansShoppingScene",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/_Discover%20the%20Trends%20in%20Japan%27s%20Shopping%20Scene/Japan-shopping1.webp",
    ],
    tags: ["日本", "ショッピング", "アクティビティ", "おすすめ", "発見"],
    description:
      "日本はショッパーにとっての楽園であり、伝統的な体験と現代的な体験が融合しています。にぎやかな市場から最先端の店舗まで、日本でのショッピングはまさに冒険です。",
    category: "旅行",
    nation: "日本",
    body: `
        <div class="container">
          <div class="content">
            <div class="header">
              <h1>日本のショッピングシーンのトレンドを発見する</h1>
            <p class="description">
                日本はショッパーにとっての楽園であり、伝統的な体験と現代的な体験が融合しています。にぎやかな市場から最先端の店舗まで、日本でのショッピングはまさに冒険です。この記事では、最新のトレンドと旅行者におすすめの日本のショッピングスポットを探ります。
            </p>
            <h3 class="section-title">伝統的な市場と工芸品店</h3>
            <div class="gallery">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/_Discover%20the%20Trends%20in%20Japan%27s%20Shopping%20Scene/1.png"
                  alt="日本のショッピングシーンのトレンドを発見する"
                />
                <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/_Discover%20the%20Trends%20in%20Japan%27s%20Shopping%20Scene/2.png"
                alt="日本のショッピングシーンのトレンドを発見する"
              />
              </div>
            <p class="section-text">
                伝統的な工芸品を愛でる人にとって、日本には独特な手作り品を販売する無数の市場と店舗があります。<br><br>
                浅草<br>
                東京の浅草は、良いスタート地点です。ここには、50以上の店舗が並ぶ仲見世通りがあり、伝統的なお菓子、お土産、工芸品が販売されています。このエリアは、本物の日本の贈り物を探す観光客に特に人気があります。<br><br>
                京都工芸品センター<br>
                次に、京都工芸品センターに向かいましょう。このセンターは、陶器、織物、木版画などの幅広い伝統工芸品で有名です。日本の職人技を学び、独特なアイテムを手に入れるのに最適な場所です。
            </p>
            <h3 class="section-title">ハイテク電化製品店</h3>
            <p class="section-text">
                日本は最先端の技術でも知られています。日本の電化製品店では、他のどこでも見つからない最新のガジェットが揃っています。<br><br>
                秋葉原<br>
                東京の秋葉原は、電化製品の一大メッカです。しばしば「電気街」と呼ばれ、コンピュータからアニメグッズまですべてを扱う店舗が軒を連ねています。ヨドバシカメラやビックカメラなどの大型店舗には、電化製品関連の全てのものが扱われる複数のフロアがあります。<br><br>
                大阪の電電城<br>
                もう一つのテクノロジー愛好家に人気のスポットは、大阪の電電城です。秋葉原に似て、幅広い電化製品やゲームグッズを扱っています。日本のテクノロジーシーンを探索したい人には必見です。
            </p>
            <h3 class="section-title">ファッション地区</h3>
            <div class="gallery">
                <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/_Discover%20the%20Trends%20in%20Japan%27s%20Shopping%20Scene/3.png"
                alt="日本のショッピングシーンのトレンドを発見する"
              />
              <img
              src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/_Discover%20the%20Trends%20in%20Japan%27s%20Shopping%20Scene/4.png"
              alt="日本のショッピングシーンのトレンドを発見する"
            />
            </div>
            <p class="section-text">
                日本はファッションのトレンドセッターです。高級ブランドが好きな人でも、クイルなストリートスタイルが好きな人でも、日本には全ての人にぴったりのものがあります。<br><br>
                原宿<br>
                原宿はストリートファッションで有名です。竹下通りには、トレンディな服、アクセサリー、独特なアイテムを販売する店舗が並んでいます。日本の若者文化を体験し、スタイリッシュなコートを手に入れるのに最適な場所です。<br><br>
                渋谷<br>
                渋谷はもう一つのファッションハブです。渋谷109ビルは若い女性にとってのショッピングの天国で、最新の日本ファッションが揃っています。渋谷には多くの国際ブランドもあり、バランスの取れたショッピング目的地となっています。
            </p>
            <h3 class="section-title">ポップカルチャーショップ</h3>
            <p class="section-text">
                日本は多くの愛されるポップカルチャーアイコンの発祥の地です。アニメ、マンガ、ビデオゲームのファンには、数多くの専門店があります。<br><br>
                中野ブロードウェイ<br>
                東京の中野ブロードウェイは、ポップカルチャー愛好家にとっての楽園です。この多層構造の複合施設には、ヴィンテージ玩具、マンガ、コレクショングッズを販売する店舗がいっぱいです。日本のポップカルチャーの奥深くに潜むものを探し求める人にとっては宝の山です。
            </p>
            <p class="footer-text">
                日本でのショッピングは、古と新が融合した多様な体験を提供します。伝統的な工芸品、最先端の電化製品、最新のファッショントレンドのどれに興味があるにせよ、日本にはすべての旅行者にぴったりのものがあります。ですから、荷物を詰めて、日本の活気に満ちたショッピングシーンを探索する準備をしましょう！
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 8,
    title: "ダイビングとシュノーケリング：サンゴ礁を探索する",
    urlinform: "DivingandSnorkelingExploretheReefs",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Diving%20and%20Snorkeling%20Explore%20the%20Reefs/diving-snorkeling1.webp",
    ],
    tags: [
      "水中アドベンチャー",
      "島々巡り",
      "ダイビングのヒント",
      "海洋生物探索",
      "最高のダイビングスポット",
    ],
    description:
      "水中世界を探索することは、最もスリリングな体験の一つです。インドネシアは、透き通った水と活気に満ちた海洋生物に恵まれ、世界で最良のダイビングとシュノーケリングのスポットのいくつかを提供します。",
    category: "旅行",
    nation: "インドネシア",
    body: `
        <div class="container">
          <div class="content">
            <div class="header">
              <h1>ダイビングとシュノーケリング：サンゴ礁を探索する</h1>
            <p class="description">
                水中世界を探索することは、最もスリリングな体験の一つです。インドネシアは、透き通った水と活気に満ちた海洋生物に恵まれ、世界で最良のダイビングとシュノーケリングのスポットのいくつかを提供します。経験豊富のダイバーであろうと、初めてシュノーケリングを試す人であろうと、インドネシアには全ての人にぴったりのものがあります。この記事では、インドネシアでのダイビングとシュノーケリングのトップスポットを掘り下げ、スキューバダイビングとシュノーケリングの違いを説明します。
            </p>
            <h3 class="section-title">スキューバダイビングとシュノーケリングの違い</h3>
            <div class="gallery">
                <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Diving%20and%20Snorkeling%20Explore%20the%20Reefs/1.png"
                alt="ダイビングとシュノーケリング：サンゴ礁を探索する"
                />
                <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Diving%20and%20Snorkeling%20Explore%20the%20Reefs/2.png"
                alt="ダイビングとシュノーケリング：サンゴ礁を探索する"
                />
            </div>
            <p class="section-text">
                深度と滞在時間<br>
                スキューバダイビングとシュノーケリングの主な違いの一つは、到達できる深度です。シュノーケリングは通常水面近くで行われますが、スキューバダイビングではより深い水域を探索することができます。これはまた、スキューバダイバーがエアタンクのおかげで長時間水中に滞在できることを意味します。<br><br>
                装備<br>
                もう一つの重要な違いは、使用する装備です。シュノーケラーはマスク、シュノーケル、フィンを使用しますが、これらは比較的使いやすく、最小限のトレーニングしか必要ありません。一方、スキューバダイバーは、エアタンク、レギュレーター、浮力調整装置、ウェットスーツなどの完全なギアが必要です。追加の装備により、ダイバーはより深く探索し、長時間水中に滞在することができます。<br><br>
                トレーニング<br>
                シュノーケリングはほとんどトレーニングを必要としないため、ほぼ誰にでもアクセス可能です。しかし、スキューバダイビングには適切なトレーニングと資格が必要です。ダイビングを開始する前に、基本的なスキル、安全プロトコル、装備の使用法をカバーするコースを受講する必要があります。
            </p>
            <h3 class="section-title">インドネシアの最高のダイビングスポット</h3>
            <div class="gallery">
                <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Diving%20and%20Snorkeling%20Explore%20the%20Reefs/3.png"
                alt="ダイビングとシュノーケリング：サンゴ礁を探索する"
                />
                <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Diving%20and%20Snorkeling%20Explore%20the%20Reefs/4.png"
                alt="ダイビングとシュノーケリング：サンゴ礁を探索する"
                />
            </div>
            <p class="section-text">
                ラジャアンパット<br>
                ラジャアンパットは、インドネシアで最良のダイビングスポットの一つとしてしばしば称賛されています。この地域には1,500種以上の魚と無数のサンゴが生息しています。ダイバーはカラフルなサンゴ礁を探索し、マンタレイと一緒に泳ぎ、ウォベゴンザメのような珍しい種を見つけることさえできます。<br><br>
                コモド国立公園<br>
                もう一つの必見スポットはコモド国立公園です。有名なコモドドラゴンの生息地であるだけでなく、この公園は素晴らしいダイビングの機会を提供します。ここの海洋生物には、ピグミーシーホースから大型の魚群、サンゴ礁のサメまで、あらゆるものが含まれます。公園の強い海流は、アドレナリンを求める経験豊富なダイバーにとっても最適なスポットとなっています。
            </p>
            <h3 class="section-title">インドネシアでシュノーケリングとスキューバダイビングを試す</h3>
            <p class="section-text">
                シュノーケリング<br>
                シュノーケリングは、大規模なトレーニングを必要とせずにサンゴ礁を探索する素敵な方法です。必要なのはマスク、シュノーケル、フィンだけです。インドネシアでのシュノーケリングのベストスポットには、ギリ諸島やブナケン国立公園が含まれます。ここでは、サンゴ礁の上を浮かび、カラフルなサンゴと多様な海洋生物の景色を楽しむことができます。<br><br>
                スキューバダイビング<br>
                スキューバダイビングでは、水中世界と密接に触れ合うことができます。シュノーケリングとは異なり、ダイビングではより深い水域を探索し、長時間水中に潜ることができます。スキューバダイビングを試してみたい場合は、インドネシアの多くのスポットで初心者向けのコースが提供されています。人気の目的地には、バリ島と前述のラジャアンパット、コモド国立公園が含まれます。
            </p>
            <p class="footer-text">
                シュノーケリングとスキューバダイビングのどちらに興味があるにせよ、インドネシアは水中世界を探索するための最高のスポットのいくつかを提供します。ラジャアンパットの活気に満ちたサンゴ礁から、コモド国立公園のスリリングなダイビングまで、誰にでも楽しめるものがあります。ですから、装備を手にして、忘れられない冒険に飛び込みましょう。
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 9,
    title: "四季を通じて日本の自然美を楽しむ",
    urlinform: "ExperiencingJapansNaturalBeautyYear-Round",
    css: `${detailPageCss1}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Experiencing%20Japan%27s%20Natural%20Beauty%20Year-Round/japan-natural1.webp",
    ],
    tags: [
      "日本",
      "季節の景色",
      "日本旅行",
      "行くべき場所",
      "アウトドアアドベンチャー",
    ],
    description:
      "日本は一年を通じて息をのむほどの自然美を誇る国です。春の桜から秋の紅葉まで、四季それぞれが独特の体験を提供します。",
    category: "旅行",
    nation: "日本",
    body: `
        <div class="container">
          <div class="content">
            <div class="header">
              <h1>四季を通じて日本の自然美を楽しむ</h1>
            <p class="description">
                日本は一年を通じて息をのむほどの自然美を誇る国です。春の桜から秋の紅葉まで、四季それぞれが独特の体験を提供します。この記事では、一年を通じて日本の自然美を楽しむ方法を案内し、あなたの体験をさらに豊かにする人気の日本の化粧品を紹介します。
            </p>
            <h3 class="section-title">春：桜</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Experiencing%20Japan%27s%20Natural%20Beauty%20Year-Round/1.png"
                  alt="四季を通じて日本の自然美を楽しむ"
                />
              </div>
            <p class="section-text">
                日本の春は、桜、すなわち「サクラ」の季節と同義です。これらの繊細なピンクの花は3月下旬から4月上旬にかけて咲き、「花見」（花を鑑賞する）パーティーで祝われます。人気のスポットには、東京の上野公園や京都の円山公園があります。桜の体験を最大限に楽しむために、春の香りを持つサクラスケントのボディローションや香水などの日本の化粧品を使用することを検討してみてください。
            </p>
            <h3 class="section-title">夏：ビーチと山の冒険</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Experiencing%20Japan%27s%20Natural%20Beauty%20Year-Round/2.png"
                  alt="四季を通じて日本の自然美を楽しむ"
                />
              </div>
            <p class="section-text">
                日本の夏は、アウトドア活動の季節です。沖縄のビーチでくつろぐのが好きな人でも、日本アルプスでハイキングを楽しむ人でも、誰にでも楽しめるものがあります。活気に満ちたサンゴ礁を探索したり、透き通った海でウォータースポーツを楽しんだりしてください。強い夏の太陽から肌を守るために、ビオレなどの人気の日本の化粧品ブランドの日焼け止めを必ず持参してください。
            </p>
            <h3 class="section-title">秋：紅葉</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Experiencing%20Japan%27s%20Natural%20Beauty%20Year-Round/3.png"
                  alt="四季を通じて日本の自然美を楽しむ"
                />
              </div>
            <p class="section-text">
                秋はおそらく日本で最も絵画的な季節です。変わる葉、いわゆる「紅葉」は、赤、オレンジ、黄色の美しい風景を演出します。有名な紅葉スポットには、京都の嵐山や栃木県の日光があります。秋の体験をさらに楽しむために、ツバキ油などの天然成分を使用した日本の化粧品を試してみてください。これらは、天気が涼しくなる中で肌を保湿するのに役立ちます。
            </p>
            <h3 class="section-title">冬：雪と温泉</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Experiencing%20Japan%27s%20Natural%20Beauty%20Year-Round/4.png"
                  alt="四季を通じて日本の自然美を楽しむ"
                />
              </div>
            <p class="section-text">
                日本の冬は、雪に覆われた風景と癒しの温泉、いわゆる「温泉」による魔法のような体験を提供します。スキー愛好家には、北海道や長野に世界クラスのリゾートがあります。坂を下った一日の後は、温泉で体と心を癒してください。天然温泉ミネラルが配合された保湿クリームやローションなどの日本の化粧品は、寒い季節に肌を柔らかく滑らかに保つのに役立ちます。
            </p>
            <h3 class="section-title">通年の美容コツ</h3>
            <p class="section-text">
                日本の化粧品は、天然成分と革新的な配合で有名です。LDKマガジンでは、さまざまな季節や肌質に合った商品がよく取り上げられています。以下は通年の美容コツです：<br><br>
                - 保湿：保湿フェイシャルマスクやクリームを使用して、肌を潤いに満ちた状態に保ちましょう。
                - 保護：季節を問わず、毎日日焼け止めを塗りましょう。
                - クレンジング：肌の天然オイルを奪わずに不純物を取り除くために、温和なクレンザーを使用しましょう。
            </p>
            <p class="footer-text">
                日本の自然美は、一年を通じて楽しめる宝です。春の桜から冬の雪景色まで、四季それぞれが独特の魅力と体験を提供します。あなたの旅に、自然の輝きを引き出し、肌を健康に保つ日本の化粧品を加えてみてください。ビーチ、山、温泉を探索するにせよ、日本は四季を通じて特別な何かを提供します。<br><br>
                日本の自然美を体験する準備はできていますか？
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 10,
    title: "日本の美味しい料理を探求する",
    urlinform: "ExploreJapansCulinaryDelights",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Exploring%20Japan%27s%20Culinary%20Delights/japanese-food1.webp",
    ],
    tags: [
      "日本料理の探求",
      "ストリートフード",
      "食べるべきもの",
      "寿司と刺身の楽しみ",
      "レストランのおすすめ",
    ],
    description:
      "日本は豊かな文化、美しい風景、特に多様で美味しい料理で知られる国です。伝統的な料理から現代的なフュージョンまで、日本料理には誰もが楽しめるものがあります。",
    category: "食べ物",
    nation: "日本",
    body: `
        <div class="container">
          <div class="content">
            <div class="header">
              <h1>日本の美味しい料理を探求する</h1>
            <p class="description">
                日本は豊かな文化、美しい風景、特に多様で美味しい料理で知られる国です。
                伝統的な料理から現代的なフュージョンまで、日本料理には誰もが楽しめるものがあります。
                この記事では、日本で最も愛される料理のいくつかを巡る旅に出ましょう。
                これらの食欲をそそるおいしいもので、あなたの味覚を満足させましょう！           
            </p>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Exploring%20Japan%27s%20Culinary%20Delights/1.png"
                  alt="Explore Japan's Culinary Delights"
                />
            </div>
            <h3 class="section-title">寿司と刺身</h3>
            <p class="section-text">
                人々が日本料理を考えるとき、しばしば寿司と刺身が思い浮かびます。
                これらの料理は、使用される食材の新鮮さと品質を際立たせます。
                寿司は酢飯に生魚、野菜、海藻などの食材を組み合わせたものです。
                一方、刺身は米を伴わずに薄切りにした生魚またはシーフードを提供する料理です。
                両方の料理は、しばしば醤油、ワサビ、漬け生姜と一緒に楽しまれます。   
            </p>
            <h3 class="section-title">日本のストリートフード</h3>
            <div class="image-container">
                <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Exploring%20Japan%27s%20Culinary%20Delights/2.png"
                alt="Explore Japan's Culinary Delights"
                /> 
            </div>
            <p class="section-text">
                日本のストリートフードシーンは活気に満ちており、持ち運びに便利なさまざまなスナックや小料理を提供しています。
                人気のストリートフードには以下のようなものがあります：<br><br>
                たこ焼き<br>
                たこ焼きは、小麦粉、卵、出汁のバッターから作られる風味豊かなタコのボールです。
                特殊な型のパンで焼かれ、たこ焼きソース、マヨネーズ、カツオブシ、海苔粉末がトッピングされます。
                これらの一口サイズのスナックは、外はカリッとして中は柔らかいです。<br><br>
                お好み焼き<br>
                お好み焼きは、小麦粉、卵、刻んだキャベツのバッターから作られる風味豊かなパンケーキで、肉、シーフード、野菜などのさまざまな食材が混ぜられます。
                パンケーキはグリドルで焼かれ、お好み焼きソース、マヨネーズ、カツオブシ、海苔粉末がトッピングされます。
            </p>
            <h3 class="section-title">日本のデザート</h3>
            <div class="image-container">
              <img
              src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Exploring%20Japan%27s%20Culinary%20Delights/3.png"
              alt="Explore Japan's Culinary Delights"
              />
            </div>
            <p class="section-text">
                日本には、確かに甘党を満足させるであろうさまざまな独特で美味しいデザートもあります。
                人気の日本のデザートには以下のようなものがあります：<br><br>
                もち<br>
                もちは、餅米をついて粘り気のあるペーストにしたものです。
                そのまま食べることも、餡、アイスクリーム、果物などの甘い詰め物を入れて食べることもできます。
                もちは、特別な行事や祭りの際にしばしば楽しまれます。<br><br>
                どら焼き<br>
                どら焼きは、通常餡を挟んだ日本のパンケーキサンドイッチの一種です。
                パンケーキはカステラに似たバッターから作られ、軽くふわふわした食感になります。
                どら焼きは人気のスナックで、多くのコンビニエンスストアやパン屋で見つけることができます。
            </p>
            <h3 class="section-title">ラーメン</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Exploring%20Japan%27s%20Culinary%20Delights/4.png"
                  alt="Explore Japan's Culinary Delights"
                />
              </div>
            <p class="section-text">
                ラーメンは、国際的な人気を博した日本の人気の麺スープです。
                中華風の小麦麺が、通常豚、鶏、または魚から作られる風味豊かなスープの中に出されます。
                この料理には通常、豚の切り身、ゆで卵、ネギ、海苔（海藻）などのトッピングが添えられます。
                ラーメンには多くの地域バリエーションがあり、それぞれ独自の味わいを持っています。            
            </p>
            <h3 class="section-title">天ぷら</h3>
            <p class="section-text">
                天ぷらは、衣をつけて揚げたシーフードと野菜の日本料理です。
                衣は冷水と小麦粉から作られ、軽くカリッとしたコーティングになります。
                天ぷらは、しばしば醤油、出汁、味醂から作られるつゆと、おろし大根と一緒に提供されます。
            </p>
            <div class="image-container">
                <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Exploring%20Japan%27s%20Culinary%20Delights/5.png"
                alt="Explore Japan's Culinary Delights"
                />
            </div>
            <p class="footer-text">
                日本の美味しい料理を探求することは、忘れられない思い出と、その国の豊かな食文化への深い理解を残す旅になるでしょう。
                あなたが旨いものが好きな人であろうと甘いものが好きな人であろうと、日本の多様な料理には誰もが楽しめるものがあります。<br><br>
                これらの日本料理を試したことがありますか？
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 11,
    title: "インドネシアの島々を探索する：バリ、ジャワ、そしてそれ以上",
    urlinform: "ExploringIndonesiasIslandsBaliJavaandBeyond",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Exploring%20Indonesia%E2%80%99s%20Islands%20Bali,%20Java,%20and%20Beyond/indonesia-islands1.webp",
    ],
    tags: [
      "バリの魅力",
      "ジャワの探索",
      "熱帯の休暇",
      "ビーチの避難所",
      "島々の特徴",
    ],
    description:
      "インドネシアは何千もの島々から成る国で、それぞれが独特の体験を提供します。バリの豊かな風景からジャワの賑やかな街まで、すべての旅行者にぴったりのものがあります。",
    category: "ガイド",
    nation: "インドネシア",
    body: `
        <div class="container">
          <div class="content">
            <div class="header">
              <h1>インドネシアの島々を探索する：バリ、ジャワ、そしてそれ以上</h1>
            <p class="description">
                インドネシアは何千もの島々から成る国で、それぞれが独特の体験を提供します。バリの豊かな風景からジャワの賑やかな街まで、すべての旅行者にぴったりのものがあります。このインドネシア旅行ガイドは、あなたの完璧な休暇計画を立てるのに役立ちます。
            </p>
            <h3 class="section-title">バリ旅行ガイド</h3>
            <p class="section-text">
                バリは多くの観光客がインドネシアを訪れる際の最初の立ち寄り先となっています。見事なビーチ、活気に満ちた文化、友好的な地元の人々で知られるバリには、すべてが備わっています。
            </p>
            <h3 class="section-title">バリで必見の観光名所</h3>
            <div class="gallery">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Exploring%20Indonesia%E2%80%99s%20Islands%20Bali,%20Java,%20and%20Beyond/1.png"
                  alt="Exploring Indonesia's Islands: Bali, Java, and Beyond"
                />
                <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Exploring%20Indonesia%E2%80%99s%20Islands%20Bali,%20Java,%20and%20Beyond/4.png"
                alt="Exploring Indonesia's Islands: Bali, Java, and Beyond"
                />
              </div>
            <p class="section-text">
                - ウブド：この町はバリの文化の中心地です。ウブドモンキーフォレストを訪れ、地元の美術ギャラリーを探索し、伝統的なバリの舞踊パフォーマンスを楽しみましょう。<br>
                - クタビーチ：活気に満ちたナイトライフと優れたサーフィン条件で有名なクタビーチは必見です。<br>
                - タナロット寺院：この象徴的な海の寺院は、バリで最も撮影されるスポットの一つです。日没時に訪れると最高の景色が楽しめます。
                
            </p>
            <h3 class="section-title">バリを旅行する際のヒント</h3>
            <p class="section-text">
                - 交通手段：スクーターを借りるのが人気の移動方法です。タクシーやライドハーネスアプリも利用可能です。<br>
                - ローカル料理：ナシゴレン（焼き飯）やバビグリング（子豚）などの地元の料理を試すのをお見逃しなく。<br>
                - 宿泊施設：バリにはバジェットホステルから高級リゾートまでさまざまな宿泊施設があります。
            </p>
            <h3 class="section-title">ジャワを探索する</h3>
            <p class="section-text">
                ジャワはインドネシアで最も人口の多い島で、自然の美しさと都市の興奮を兼ね備えています。
            </p>
            <h3 class="section-title">ジャワの人気の目的地</h3>
            <div class="gallery">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Exploring%20Indonesia%E2%80%99s%20Islands%20Bali,%20Java,%20and%20Beyond/2.png"
                  alt="Exploring Indonesia's Islands: Bali, Java, and Beyond"
                />
                <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Exploring%20Indonesia%E2%80%99s%20Islands%20Bali,%20Java,%20and%20Beyond/3.png"
                alt="Exploring Indonesia's Islands: Bali, Java, and Beyond"
                />
              </div>
            <p class="section-text">
                - ジャカルタ：インドネシアの首都であるジャカルタは、ショッピングモール、博物館、活気に満ちたナイトライフがある賑やかな大都市です。<br>
                - ヨガヤクルタ：豊かな歴史と文化で知られるヨガヤクルタには、有名なボロブドゥル寺院とプランバナン寺院があります。<br>
                - ブロモ山：この活火山は人気のハイキングスポットです。山頂からの日の出の景色は息をのむほどです。
            </p>
            <h3 class="section-title">ジャワを旅行する際のヒント</h3>
            <p class="section-text">
                - 公共交通機関：ジャワにはバスや電車などの整備された公共交通システムがあります。<br>
                - ローカルフード：ヨガヤクルタのグデグ（ジャックフルーツの煮込み）とジャカルタのサテアヤム（チキンサテ）を試してみてください。<br>
            </p>
            <h3 class="section-title">バリとジャワを越えた島々</h3>
            <p class="section-text">
                インドネシアには探索する価値のある他の多くの島々があり、それぞれ独自の魅力があります。<br><br>
                ロンボック<br>
                ロンボックはしばしばバリと比較されますが、人が少ないです。センギギビーチなどの美しいビーチと、リンジャニ山への挑戦的なハイキングコースを提供しています。<br><br>
                フローレス<br>
                フローレスはその見事な風景とコモド国立公園で知られており、そこでは有名なコモドドラゴンを見ることができます。シュノーケリングとダイビングはここで人気のアクティビティです。<br><br>
                スマトラ<br>
                スマトラは自然愛好家にぴったりです。世界最大の火山湖であるトバ湖を訪れたり、野生のオランウータンを見るためにブキトラワンの豊かな熱帯雨林でトレッキングしたりしてみてください。  
            </p>
            <p class="footer-text">
                インドネシアはとてもたくさんの魅力を持つ多様な国です。ゆったりとしたビーチホリデーを求めている人でも、文化体験を求めている人でも、自然の冒険を求めている人でも、ここで見つけることができます。バリとジャワから始めて、そして本当に忘れられない旅のためにあまり知られていない島々を探索しに出かけましょう。<br><br>
                これらの島々のどれかを訪れたことがありますか？
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 12,
    title: "日本の寺院と神社を探索する",
    urlinform: "ExploringJapansTemplesandShrines",
    css: `${detailPageCss1}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Exploring%20Japan%E2%80%99s%20Temples%20and%20Shrines/japan-temples1.webp",
    ],
    tags: ["日本の精神性", "寺院", "探索", "歴史的建造物", "日本の文化遺産"],
    description:
      "日本の寺院と神社を探索することは、歴史と精神性が完璧に融合した世界に足を踏み入れるようなものです。これらの神聖な場所は、日本の豊かな文化遺産を垣間見ることができ、すべての旅行者にとって必見のスポットです。",
    category: "旅行",
    nation: "日本",
    body: `
        <div class="container">
          <div class="content">
            <div class="header">
              <h1>日本の寺院と神社を探索する</h1>
            <p class="description">
                日本の寺院と神社を探索することは、歴史と精神性が完璧に融合した世界に足を踏み入れるようなものです。
                これらの神聖な場所は、日本の豊かな文化遺産を垣間見ることができ、すべての旅行者にとって必見のスポットです。
                この記事では、訪れるべき最も象徴的な寺院と神社のいくつかを紹介します。            
            </p>
            <h3 class="section-title">象徴的な伏見稲荷大社</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Exploring%20Japan%E2%80%99s%20Temples%20and%20Shrines/1.png"
                  alt="Exploring Japan's Temples and Shrines"
                />
              </div>
            <p class="section-text">
                京都にある伏見稲荷大社は、何千もの朱色の鳥居が並び、山を登る魅惑的な道を作り出すことで有名です。
                稲荷神、神道の稲の神に捧げられたこの神社は、毎年何百万人もの訪問者を引き付けます。
                鳥居の道を歩くことで、素敵な景色と下の賑やかな都市からの静かな逃避行が楽しめます。            
            </p>
            <h3 class="section-title">荘厳な金閣寺</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Exploring%20Japan%E2%80%99s%20Temples%20and%20Shrines/2.png"
                  alt="Exploring Japan's Temples and Shrines"
                />
              </div>
            <p class="section-text">
                金閣寺としても知られる鹿苑寺は、京都で最も印象的な観光名所の一つです。
                寺院の上の2階は金箔で覆われており、周囲の池に美しく映ります。
                もともとは将軍の隠居高齢者の別荘として建てられたが、後に禅宗の寺院に改築された。
                金閣寺を訪れると、特に池の静かな水面に寺院が映るときに、静かな体験が得られます。            
            </p>
            <h3 class="section-title">歴史的な浅草寺</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Exploring%20Japan%E2%80%99s%20Temples%20and%20Shrines/3.png"
                  alt="Exploring Japan's Temples and Shrines"
                />
              </div>
            <p class="section-text">
                東京の浅草地区にある浅草寺は、東京で最も古い寺院であり、最も重要な寺院の一つです。
                慈悲深い仏教の女神である観音菩薩に捧げられたこの寺院は、活気に満ちた活動の中心地です。
                訪問者は、迫力のある雷門を通って入り、そこから伝統的なお菓子やお土産が並ぶ賑やかな商店街につながります。            
            </p>
            <h3 class="section-title">静かな明治神宮</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Exploring%20Japan%E2%80%99s%20Temples%20and%20Shrines/4.png"
                  alt="Exploring Japan's Temples and Shrines"
                />
              </div>
            <p class="section-text">
                東京の中心部にある明治神宮は、都会の喧騒から静かな避難所を提供します。
                明治天皇と昭憲皇太后に捧げられたこの神社は、美しい森林地帯の中にあります。
                訪問者はしばしば、木札に願い事を書いたり、神社の手水舎で清めの儀式に参加したりするなど、伝統的な儀式に参加します。            
            </p>
            <h3 class="section-title">絵のような厳島神社</h3>
            <p class="section-text">
                宮島にある厳島神社は、満潮時に水面に浮かんでいるように見える「浮き鳥居」で有名です。
                このユネスコの世界遺産は、海と嵐の神道の神々に捧げられています。
                神社建築そのものは水面に架かる高床式になっており、独特で絵のような風景を演出しています。            
            </p>
            <p class="footer-text">
                日本の寺院と神社は美しい建造物以上のものです。それらは、国の深い精神的および文化的歴史の証です。
                象徴的な伏見稲荷大社から静かな明治神宮まで、それぞれの場所は見逃せない独特の体験を提供します。
                あなたが平和、美しさ、または日本文化のより深い理解を求めているかどうかに関わらず、これらの必見のスポットは完璧な出発点を提供します。<br><br>
                これらの寺院や神社のどれかを訪れたことがありますか？
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 13,
    title: "温泉から茶道まで",
    urlinform: "FromOnsetoTeaCeremonies",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/From%20Onsen%20to%20Tea%20Ceremonies/hotspring-teaceremony1.webp",
    ],
    tags: [
      "日本",
      "健康リトリート",
      "体験",
      "日本の儀式",
      "おすすめアクティビティ",
    ],
    description:
      "日本は伝統と文化に富む国です。初めて訪れる人でも、何度も訪れる人でも、常に新しい発見があります。",
    category: "旅行",
    nation: "日本",
    body: `
        <div class="container">
          <div class="content">
            <div class="header">
              <h1>温泉から茶道まで</h1>
            <p class="description">
                日本は伝統と文化に富む国です。
                初めて訪れる人でも、何度も訪れる人でも、常に新しい発見があります。
                日本で体験できる最もユニークで静かな2つの体験は、温泉訪問と茶道参加です。
                これらのアクティビティはリラクゼーションだけでなく、日本文化への深い理解を提供します。
            </p>
            <h3 class="section-title">温泉とは？</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/From%20Onsen%20to%20Tea%20Ceremonies/1.png"
                  alt="温泉から茶道まで"
                />
              </div>
            <p class="section-text">
                温泉は日本の温泉です。
                これらの自然温泉は全国に点在し、地元の人々だけでなく観光客にも人気の目的地です。
                温泉の水はミネラルが豊富で、癒しの効果があると信じられています。
            </p>
            <h3 class="section-title">温泉を楽しむ方法</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/From%20Onsen%20to%20Tea%20Ceremonies/2.png"
                  alt="温泉から茶道まで"
                />
              </div>
            <p class="section-text">
                温泉に入る前に、体を十分に洗浄することが重要です。
                ほとんどの温泉には、湯に浸かる前に洗い流せる洗浄エリアがあります。
                また、水着は禁止されていることに注意する必要があります。
                この体験は、水中の自然ミネラルを十分に楽しむために、裸で楽しむことを目的としています。
            </p>
            <h3 class="section-title">日本の茶道</h3>
            <div class="gallery">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/From%20Onsen%20to%20Tea%20Ceremonies/3.png"
                  alt="温泉から茶道まで"
                />
                <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/From%20Onsen%20to%20Tea%20Ceremonies/4.png"
                alt="温泉から茶道まで"
                />
              </div>
            <p class="section-text">
                日本の茶道は、「茶道」または「茶の湯」とも呼ばれ、禅仏教の影響を受けた伝統的な儀式です。
                抹茶（粉末緑茶）の調理と消費が含まれます。
                儀式は非常に形式づくられており、正念、尊重、日常の行動の単純な美しさを強調しています。
            </p>
            <h3 class="section-title">茶道のステップ</h3>
            <p class="section-text">
                茶道は、ホストがゲストの前で器具を清掃することから始まります。
                その後、抹茶を調理し、お湯に泡立つまでかき混ぜます。
                ホストは次にお茶を各ゲストに提供し、ゲストは飲む前に色と香りを楽しむ時間を持ちます。
            </p>
            <h3 class="section-title">これらの体験を試すべき理由</h3>
            <p class="section-text">
                温泉を訪れる主な理由の1つは、自然と触れ合う機会があることです。
                多くの温泉は、山や海岸近くなどの景色の美しい場所にあります。
                自然の環境が全体的な体験を高め、くつろぐのに最適な方法になります。
            </p>
            <h3 class="section-title">内なる平和を見つける</h3>
            <p class="section-text">
                茶道に参加することで、禅の瞬間を体験できます。
                儀式的な性質が正念を促し、現在の瞬間に集中するのに役立ちます。
                日常の喧騒からの静かな逃避場所です。
            </p>
            <h3 class="section-title">覚えておくべきこと</h3>
            <p class="section-text">
                両方の体験が非常にやりがいがありますが、覚えておくべきいくつかのことがあります。
                温泉の場合、入浴禁止になっていることが多いので、タトゥーを包帯やシールで覆う必要があることに注意してください。
                茶道の場合は、ホストの指示に従い、プロセス全体を通して敬意を表すことが重要です。
            </p>
            <p class="footer-text">
                温泉の心地よい湯から茶道の落ち着いた儀式まで、日本はリラックスし、豊かな文化に浸るユニークな方法を提供します。
                自然と触れ合いたい人でも、内なる平和を求める人でも、これらの体験は見逃せません。<br><br>
                あなたは温泉を体験したことがありますか？ または茶道に参加したことがありますか？
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 14,
    title: "インドネシアの文化遺産",
    urlinform: "IndonesiasCulturalHeritage",
    css: `${detailPageCss1}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Indonesia%E2%80%99s%20Cultural%20Heritage/indonesia-cultural1.webp",
    ],
    tags: [
      "インドネシアの伝統",
      "人形劇",
      "バリ島文化",
      "バティックワークショップ",
      "歴史的建造物を発見",
    ],
    description:
      "インドネシアは文化遺産に富む国で、旅行者に多様な体験を提供します。古代の寺院から伝統的なダンスまで、インドネシアの独特な歴史と文化を紹介する数多くの場所と見所があります。",
    category: "旅行",
    nation: "インドネシア",
    body: `
        <div class="container">
          <div class="content">
            <div class="header">
              <h1>インドネシアの文化遺産</h1>
            <p class="description">
                インドネシアは文化遺産に富む国で、旅行者に多様な体験を提供します。古代の寺院から伝統的なダンスまで、インドネシアの独特な歴史と文化を紹介する数多くの場所と見所があります。
            </p>
            <h3 class="section-title">古代寺院</h3>
            <div class="gallery">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Indonesia%E2%80%99s%20Cultural%20Heritage/1.png"
                  alt="インドネシアの文化遺産"
                />
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Indonesia%E2%80%99s%20Cultural%20Heritage/2.png"
                  alt="インドネシアの文化遺産"
                />
                <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Indonesia%E2%80%99s%20Cultural%20Heritage/3.png"
                alt="インドネシアの文化遺産"
              />          
              </div>
            <p class="section-text">
                インドネシアの文化遺産の最も重要な側面の1つは、その古代寺院です。ボロブドゥルとプランバナンは2つの必見の名所です。<br><br>
                ボロブドゥル<br>
                ボロブドゥルは世界最大の仏教寺院で、中央ジャワに位置しています。9世紀に建てられ、仏教建築と芸術の見事な例です。寺院には何千もの浮き彫りパネルと仏像が飾られています。訪問者は上部まで登って、周囲の風景を一望することができます。<br><br>            
                プランバナン<br>
                プランバナンも中央ジャワに位置し、大きなヒンドゥー教寺院群です。10世紀に建てられ、ブラフマ、ヴィシュヌ、シヴァなどのヒンドゥー教の神々に捧げられたいくつかの寺院で構成されています。入念な彫刻とそびえ立つ尖塔が、プランバナンを息をのむような光景にしています。
            </p>
            <h3 class="section-title">伝統的な芸術と工芸</h3>
            <p class="section-text">
                インドネシアは、豊かな芸術と工芸の伝統でも知られています。バティック、ワヤン、そして伝統的なダンスは、旅行者が体験できる文化的宝庫のいくつかです。<br><br>
                バティック<br>
                バティックは、ワックスと染料を使用して入念な模様を作成する伝統的な布染め技術です。この工芸はインドネシアの多くの地域で行われており、それぞれの地域には独自のスタイルがあります。訪問者はバティックの技術を学び、自分だけのデザインを作成するワークショップに参加することができます。<br><br>
                ワヤン<br>
                ワヤン、または伝統的な人形劇は、インドネシアの文化遺産のもう1つの重要な側面です。この芸術形式は、入念に彫刻され描かれた人形を使用して、インドネシアの民話、ヒンドゥー教の叙事詩、その他の出典からの物語を語ります。ワヤンの公演には、しばしば伝統的なガメラン音楽が伴奏され、魅了的な体験を作り出します。<br><br>
                文化祭<br>
                インドネシアの文化祭は、活気に満ちた祭典で、この国の伝統と習俗を垣間見ることができます。特に注目すべき2つの祭りは、ガルンガンとニェピです。<br><br>
                ガルンガン<br>
                ガルンガンはバリ島の祭りで、善が悪に勝利したことを祝うものです。この祭りは10日間続き、さまざまな儀式、供物、そして伝統的な公演が行われます。訪問者は美しく飾られた寺院や、ガルンガンの間に行われる活気ある行列を目撃することができます。<br><br>
                ニェピ<br>
                ニェピは「沈黙の日」としても知られ、もう1つの重要なバリ島の祭りです。これはバリの新年を迎える日で、完全な沈黙、断食、瞑想の日です。ニェピの前日には、大きな悪魔の像であるオゴーオゴーが登場する活気あるパレードがあり、後にそれらは悪霊を追い払うために燃やされます。   
            </p>
            <h3 class="section-title">歴史的建造物</h3>
            <div class="image-container">
                <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Indonesia%E2%80%99s%20Cultural%20Heritage/4.png"
                alt="インドネシアの文化遺産"
                />
            </div>
            <p class="section-text">
                インドネシアには、その多様な文化遺産を反映した数多くの歴史的建造物があります。<br><br>
                タナ·トラジャ<br>
                南スラウェシに位置するタナ·トラジャは、独特な葬式儀礼とトンコナンと呼ばれる伝統的な家屋で有名です。訪問者はトラジャ族の文化を学び、葬列の際に行われる精巧な儀式を目撃することができます。<br><br>          
                ヨガヤカルタ<br>
                しばしばジョグジャと呼ばれるヨガヤカルタは、中央ジャワにある都市で、豊かな文化遺産で知られています。ここにはスルタンの宮殿であるクラトンがあり、ジャワ文化の生きた博物館となっています。この都市では、ラーマヤナバレエなどのさまざまな伝統的な公演も行われています。   
            </p>
            <p class="footer-text">
                インドネシアの文化遺産は広大で多様で、旅行者には数多くの訪問場所と楽しめる体験があります。古代寺院を探索したり、伝統的な工芸に参加したり、文化祭に参加したりすると、この活気に満ちた国で常に新しい発見があります。<br><br>
                あなたはインドネシアのこれらの文化的宝庫のいずれかを訪れたことがありますか？
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 15,
    title: "インドネシア料理：風味豊かな旅",
    urlinform: "IndonesianCuisineAFlavorfulJourney",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Indonesian%20Cuisine%20A%20Flavorful%20Journey/indonesian-cuisine2.webp",
    ],
    tags: [
      "インドネシア料理",
      "おすすめ食べ物",
      "料理",
      "辛いアジア料理",
      "インドネシアレストラン",
    ],
    description:
      "1万7千以上の島から成るインドネシアは、文化と風味の融和の場です。この国の豊かな料理遺産は、インドや中国から中東やオランダまで、多様な文化的影響を物語っています。",
    category: "食べ物",
    nation: "インドネシア",
    body: `
      <div class="container">
      <div class="content">
        <div class="header">
          <h1>インドネシア料理：風味豊かな旅</h1>
        <p class="description">
            1万7千以上の島から成るインドネシアは、文化と風味の融和の場です。
            この国の豊かな料理遺産は、インドや中国から中東やオランダまで、多様な文化的影響を物語っています。
            それぞれの島が独自の味覚体験を提供し、インドネシア料理を楽しい料理の旅にしています。
            この記事では、人気のあるインドネシア料理のレシピをいくつか探り、有名なインドネシアレストランであるWarung Pulau Kelapaにも触れます。            
        </p>
        <h3 class="section-title">インドネシア料理の本質</h3>
        <p class="section-text">
            インドネシア料理は、大胆な味わいと芳香性のスパイスで知られています。主要な成分には、ココナッツミルク、唐辛子、レモングラス、ガランガル、そしてさまざまなハーブとスパイスが含まれます。これらの成分が、風味豊かで香り高い料理を作り出し、あなたの味覚に忘れられない印象を残します。
        </p>
        <h3 class="section-title">人気のインドネシア料理</h3>
        <div class="gallery">
            <img
              src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Indonesian%20Cuisine%20A%20Flavorful%20Journey/1.png"
              alt="インドネシア料理：風味豊かな旅"
            />
            <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Indonesian%20Cuisine%20A%20Flavorful%20Journey/2.png"
            alt="インドネシア料理：風味豊かな旅"
          />
          </div>
        <p class="section-text">
            ナシ·ゴレン<br>
            ナシ·ゴレン、または焼き飯は、インドネシア料理の定番です。この料理は、前もって炊いたご飯をスパイスのブレンド、醤油、そして肉または野菜の選択肢と一緒に炒めたものです。多くの場合、上に焼き卵が乗せられ、ナシ·ゴレンは一日のどの食事にも最適な料理です。<br><br>
            レンダン<br>
            レンダンは、牛肉をココナッツミルクとレモングラス、ガランガル、にんにく、ウコン、生姜、唐辛子の混合物でゆっくり煮込んだドライカレーです。この料理は、豊かで複雑な味わいで知られており、特別な機会や祝祭の際によく楽しまれます。
        </p>
        <h3 class="section-title">Warung Pulau Kelapaインドネシア料理</h3>
        <div class="image-container">
            <img
              src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Indonesian%20Cuisine%20A%20Flavorful%20Journey/4.png"
              alt="インドネシア料理：風味豊かな旅"
            />
          </div>
        <p class="section-text">
            Warung Pulau Kelapaは、インドネシアの味をあなたのテーブルに届ける人気のレストランです。挿入場所に位置し、このレストランは本格的なインドネシア料理で有名です。ナシ·ゴレンやサターなどの伝統的な人気メニューから、あまり知られていない珍味まで、Warung Pulau Kelapaはインドネシア料理の最高傑作を紹介する包括的なメニューを提供しています。
        </p>
        <h3 class="section-title">インドネシア料理におけるスパイスの重要性</h3>
        <div class="image-container">
            <img
              src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Indonesian%20Cuisine%20A%20Flavorful%20Journey/3.png"
              alt="インドネシア料理：風味豊かな旅"
            />
          </div>
        <p class="section-text">
            スパイスはインドネシア料理において重要な役割を果たします。それらは味を加えるだけでなく、薬用特性のためにも使用されます。一般的なスパイスには、ウコン、コリアンダー、クミン、クローブが含まれます。これらのスパイスはしばしばペーストに磨り潰され、多くのインドネシア料理のベースを形成します。<br><br>
            サンバル：辛い調味料<br>
            サンバルは、インドネシア料理に欠かせない辛い唐辛子ペーストです。さまざまな唐辛子、にんにく、その他のスパイスで作られ、サンバルはどんな料理にも激しいキックを加えます。しばしばサイドコンディメントとして提供され、肉、野菜、そしてご飯の味を引き立てるために使用することができます。
        </p>
        <h3 class="section-title">価値ある料理の旅</h3>
        <p class="section-text">
            インドネシア料理は、確かにどんな美食家も喜ぶであろう豊かな味の織り交ぜを提供します。初めてナシ·ゴレンを試す人でも、レンダンのボウルを味わう人でも、それぞれの料理がインドネシアの豊かな文化遺産の物語を語っています。本格的なインドネシアの味を楽しむために、Warung Pulau Kelapaへの訪問を強くお勧めします。
        </p>
        <p class="footer-text">
            インドネシア料理を通じた風味豊かな旅に乗り出す準備はできていますか？
        </p>
      </div>
    </div>
      `,
  },
  {
    id: 16,
    title: "日本のカラフルな祭りに参加しよう",
    urlinform: "JoinJapansColorfulFestivals",
    css: `${detailPageCss1}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Join%20Japan%27s%20Colorful%20Festivals/japan-festivals1.webp",
    ],
    tags: ["祭り", "日本の伝統", "お祭りの場所", "お祈り", "発見"],
    description:
      "日本は文化と伝統に富む国です。その魅力を体感する最良の方法の一つは、賑やかな祭りに参加することです。",
    category: "旅行",
    nation: "日本",
    body: `
      <div class="container">
          <div class="content">
            <div class="header">
              <h1>日本のカラフルな祭りに参加しよう</h1>
            <p class="description">
                日本は文化と伝統に富む国です。
                その魅力を体感する最良の方法の一つは、賑やかな祭りに参加することです。
                地元の人であろうと旅行者であろうと、日本の祭り（「まつり」と呼ばれます）は、誰にでも簡単に参加できるユニークな体験を提供します。
                日本で最もカラフルな祭りのいくつかを探り、旅行者がどのように参加できるか見てみましょう。
            </p>
            <h3 class="section-title">桜まつり（花見）</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Join%20Japan%27s%20Colorful%20Festivals/1.png"
                  alt="Join Japan's Colorful Festivals"
                />
              </div>
            <p class="section-text">
                桜まつり、または「花見」は、日本中の桜の開花を祝う祭りです。
                これらの祭りは通常3月下旬または4月上旬に開催されます。
                公園や庭園は、開花した桜の木の下でピクニックを楽しむ人々の集まり場になります。
                多くの都市では、伝統的な音楽、踊り、食べ物屋台が並ぶ特別なイベントも開催されます。<br><br>
                参加方法<br>
                桜まつりに参加するには、東京の上野公園や京都の円山公園などの人気の公園に足を運んでください。ピクニックブランケットとおやつを持っていき、景色を楽しみましょう。
            </p>
            <h3 class="section-title">祇園祭</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Join%20Japan%27s%20Colorful%20Festivals/2.png"
                  alt="Join Japan's Colorful Festivals"
                />
              </div>
            <p class="section-text">
                祇園祭は、7月に京都で開催される日本で最も有名な祭りの一つです。
                その歴史は千年以上に及び、美しく飾られた大型の山車が並ぶ壮大なパレードが特徴です。
                祭りは1ヶ月間続き、たくさんの行事やイベントが行われます。<br><br>
                参加方法<br>
                旅行者は、山車が展示され、通りには食べ物屋台が並ぶ宵山の夜に参加することで、祇園祭を楽しむことができます。
                本番のパレードのためには、早めに良い場所を確保してください。
            </p>
            <h3 class="section-title">札幌雪まつり</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Join%20Japan%27s%20Colorful%20Festivals/3.png"
                  alt="Join Japan's Colorful Festivals"
                />
              </div>
            <p class="section-text">
                毎年2月に北海道で開催される札幌雪まつりは、巨大な雪像や氷彫りを展示します。
                この祭りは年間数百万の観光客を集め、コンサート、ライトショー、アイススケートなどのイベントが行われます。<br><br>
                参加方法<br>
                札幌雪まつりに参加するには、札幌の大通公園に行ってください。
                暖かく着て、精巧な彫刻をゆっくりと楽しみましょう。
                多くの地元および国際的なアーティストが参加しており、本当に世界的なイベントとなっています。
            </p>
            <h3 class="section-title">阿波踊り</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Join%20Japan%27s%20Colorful%20Festivals/4.png"
                  alt="Join Japan's Colorful Festivals"
                />
              </div>
            <p class="section-text">
                8月に徳島で開催される阿波踊りは、日本最大のダンス祭りです。
                参加者は、16世紀にさかのぼる伝統的なダンスである「阿波踊り」を披露します。
                通りは踊り手、音楽家、観客でにぎわいます。<br><br>
                参加方法<br>
                訪問者は、踊り手を見るか、初心者も大歓迎の「にわか連」グループに参加することで、阿波踊りに参加できます。
                ステップを知らなくても心配しないでください—地元の人々が喜んで教えてくれます。
            </p>
            <h3 class="section-title">七夕祭り</h3>
            <p class="section-text">
                七夕祭りは、星祭りとも呼ばれ、7月初旬または8月に開催されます。
                二人の星の恋人の出会いを祝うこの祭りには、カラフルな飾り、パレード、伝統音楽があります。<br><br>
                参加方法<br>
                七夕祭りに参加するには、仙台や平塚などの盛大なお祭りが行われる都市を訪れてください。
                小さな紙切れに願い事を書き、竹の枝に飾るという地元の習俗に従ってみましょう。
            </p>
            <p class="footer-text">
                日本の祭りは、豊かな文化遺産への入り口です。
                それらは視覚的に見事なだけでなく、深く伝統に根付いています。
                桜の季節に訪れる予定であろうと、札幌の雪像を見たいと願っている人であろうと、これらの祭りは誰にでも楽しめるものを提供しています。
                ですから、カレンダーにマークをして、日本が提供する賑やかなお祭りに身を浸しましょう。<br><br>
                あなたのお気に入りの日本の祭りは何ですか？
            </p>
          </div>
        </div>
       `,
  },
  {
    id: 17,
    title: "中国で味わう地域料理",
    urlinform: "RegionalDishestoSavorinChina",
    css: `${detailPageCss1}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Regional%20Dishes%20to%20Savor%20in%20China/chinese-cuisine1.webp",
    ],
    tags: ["中華料理", "必食料理", "地域の味", "食べ歩き", "本格中華料理"],
    description:
      "中国は料理の楽園であり、豊かな味と伝統が織りなす。それぞれの地域には、その文化と歴史を語る独自の料理がある。",
    category: "食べ物",
    nation: "中國",
    body: `
      <div class="container">
          <div class="content">
            <div class="header">
              <h1>中国で味わう地域料理</h1>
            </div>
            <p class="description">
              中国は料理の楽園であり、豊かな味と伝統が織りなす。それぞれの地域には、その文化と歴史を語る独自の料理がある。中国の多様な料理を探索する予定なら、本格的で美味しく、絶対に訪れたいレストランで提供される次のような地域料理をぜひ味わってほしい。
            </p>
            <h3 class="section-title">四川: 麻婆豆腐</h3>
             <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Regional%20Dishes%20to%20Savor%20in%20China/1.png"
                  alt="Regional Dishes to Savor in China"
                />
            </div>
            <p class="section-text">
              麻婆豆腐は四川省の必食料理。この辛くて風味豊かな料理は、発酵豆板醤とみじん切りの肉から作られた辛くて油っこいソースで柔らかい豆腐の角切りを泳がせる。この料理は、四川山椒の舌をピリピリさせる感覚で知られている。辛い料理が好きなら、この料理は失望させない。
            </p>
            <h3 class="section-title">広東: 点心</h3>
            <div class="image-container">
              <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Regional%20Dishes%20to%20Savor%20in%20China/2.png"
                alt="Regional Dishes to Savor in China"
              />
            </div>
            <p class="section-text">
              点心は、伝統的にブランチで楽しまれる一口サイズの料理の一種。広東地域が起源で、これらの料理は小さな蒸し器か小さなお皿で提供される。エビ餃子（ハーガオ）からバーベキュー豚バラまん（チャーシューバオ）まで、点心は誰にでも楽しめるものを提供している。点心レストランを訪れること自体が体験であり、これらの楽しいお菓子でいっぱいのカートを押して回るウェイターがいる。
            </p>
            <h3 class="section-title">北京: 北京ダック</h3>
            <p class="section-text">
              北京ダックは北京で最も有名な料理の一つ。ダックは皮がカリカリで金褐色になるまでローストし、薄くスライスしてパンケーキ、ホイシンソース、ネギと一緒に提供する。カリカリの皮、柔らかい肉、うま味のあるソースの組み合わせがこの料理を忘れられないものにする。北京の多くのレストランは何世紀にもわたってこの料理を完成させており、特別な旅行にふさわしい。
            </p>
            <div class="image-container">
              <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Regional%20Dishes%20to%20Savor%20in%20China/3.png"
                alt="Regional Dishes to Savor in China"
              />
            </div>
            <h3 class="section-title">湖南: 毛沢東赤焼肉</h3>
            <p class="section-text">
              毛沢東主席の名前にちなんだこの料理は、湖南料理の定番。豚バラ肉は醤油、砂糖、スパイスの混合物で煮込んで柔らかく風味豊かにする。甘味とうま味の完璧なバランスで、湖南料理を探索する人なら誰もが必食。この料理は、濃厚なソースを吸い上げるために蒸しご飯と一緒に提供されることが多い。
            </p>
            <div class="image-container">
              <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Regional%20Dishes%20to%20Savor%20in%20China/4.png"
                alt="Regional Dishes to Savor in China"
              />
            </div>
            <h3 class="section-title">陝西: ビャンビャン麺</h3>
            <p class="section-text">
              ビャンビャン麺は陝西省で人気の屋台料理。これらの太くてもちもちした麺は手で引いて、唐辛子油、酢、ニンニくで作った辛くて酸味のあるソースと一緒に提供される。この料理は野菜とみじん切りの肉をトッピングすることが多く、心温まる満足感のある食事になる。ビャンビャン麺の独特の食感と大胆な味は、絶対に味わってほしい。
            </p>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Regional%20Dishes%20to%20Savor%20in%20China/5.png"
                  alt="Regional Dishes to Savor in China"
                />
            </div>
            <h3 class="section-title">浙江: 東坡肉</h3>
            <p class="section-text">
              東坡肉は浙江省の有名な料理。有名な詩人蘇東坡にちなんで名付けられたこの料理は、醤油、ワイン、砂糖で煮込んだ豚バラ肉を特徴とする。その結果、甘味とうま味の両方を兼ね備えた口の中でとろける肉。東坡肉は、美味しいソースを吸い上げるために蒸しまんじゅうと一緒に提供されることが多い。
            </p>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Regional%20Dishes%20to%20Savor%20in%20China/6.png"
                  alt="Regional Dishes to Savor in China"
                />
            </div>
            <p class="footer-text">
              これらの地域料理を味わうことで、中国の豊かな料理の伝統を味わうことができる。それぞれの料理は、本格的で忘れられない独特の体験を提供する。だから、次に中国に行く機会があったら、絶対に味わってほしい料理とそれを提供するレストランを探してみてほしい。
            </p>
            <p class="footer-text">
              これらの料理を試したことがありますか？
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 18,
    title: "上海の夜：ナイトライフシーン",
    urlinform: "ShanghaiAfterDarkNightlifeScene",
    css: `${detailPageCss1}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Shanghai%20After%20Dark%20Nightlife%20Scene/shanghai-nightlife1.webp",
    ],
    tags: [
      "上海のナイトライフ",
      "行きたい人気スポット",
      "外出スポット",
      "深夜の食事",
      "ジャズバーのおすすめ",
    ],
    description:
      "上海は眠らない街。日が沈むと、活気に満ちたナイトライフシーンが生き生きと活気づき、さまざまなアクティビティや探索スポットを提供します。",
    category: "旅行",
    nation: "中國",
    body: `
      <div class="container">
          <div class="content">
            <div class="header">
              <h1>上海の夜：ナイトライフシーン</h1>
              <p class="description">
                上海は眠らない街。日が沈むと、活気に満ちたナイトライフシーンが生き生きと活気づき、さまざまなアクティビティや探索スポットを提供します。地元の人でも観光客でも、誰にでも楽しめるものがあります。このガイドでは、賑やかなクラブから美味しい屋台まで、上海のナイトライフのベストを探索します。
              </p>
              <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Shanghai%20After%20Dark%20Nightlife%20Scene/1.png"
                  alt="Shanghai After Dark: Nightlife Scene"
                />
              </div>
              <h3 class="section-title">外灘</h3>
              <p class="section-text">
                上海のナイトライフを体験したい人なら誰もが訪れたい外灘。このウォーターフロントエリアは、無数の灯りで照らされた街のスカイラインの素晴らしい景色を提供します。遊歩道をのんびり散歩したり、屋上バーでカクテルを楽しんだり、ナイトクルーズに乗って街を違った角度から見たりしましょう。
              </p>
              <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Shanghai%20After%20Dark%20Nightlife%20Scene/2.png"
                  alt="Shanghai After Dark: Nightlife Scene"
                />
              </div>
            </div>
            <h3 class="section-title">新天地</h3>
            <p class="section-text">
              新天地は、ナイトライフ愛好家にとっても人気のスポット。この車の通れないショッピング、食事、エンターテイメント地区は、古いものと新しいものが融合しており、修復された石庫門住宅が今ではトレンディなレストラン、バー、ブティックとして使用されています。様々な料理を楽しんだり、活気に満ちた雰囲気に浸りながら、精心に作られたカクテルを味わったりしましょう。
              </p>
            <div class="image-container">
              <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Shanghai%20After%20Dark%20Nightlife%20Scene/3.png"
                alt="Shanghai After Dark: Nightlife Scene"
              />
            </div>
            <h3 class="section-title">ナイトクラブ</h3>
            <p class="section-text">
              夜通し踊るのが好きな人には、上海のクラブシーンは最高です。M1NTやBar Rougeなどの人気クラブは、トップDJや街の素晴らしい景色と共に、高エネルギーな環境を提供します。もっと親密な雰囲気が好きなら、The Shelterなどの小さな会場で、ユニークなアンダーグラウンド体験を提供します。
              </p>
            <div class="image-container">
              <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Shanghai%20After%20Dark%20Nightlife%20Scene/4.png"
                alt="Shanghai After Dark: Nightlife Scene"
              />
            </div>
            <h3 class="section-title">屋台市場</h3>
            <p class="section-text">
              上海の有名な屋台を味わわずには、ナイトライフ体験は不十分。寿宁路や吴江路などの深夜屋台市場に行って、様々な料理を試してみましょう。辛いザリガニから焼き串まで、これらの市場は見逃せない料理の冒険を提供します。
            </p>

            <h3 class="section-title">ジャズバー</h3>
            <p class="section-text">
              上海にはジャズミュージックの豊かな歴史があり、市内の様々な会場でライブ演奏を楽しむことができます。House of Blues & JazzやJZ Clubは、最も有名なスポットの2つです。親密な雰囲気の中で、スムーズなメロディーと素晴らしいドリンクで夜を楽しみましょう。
            </p>

            <h3 class="section-title">旅行者へのヒント</h3>
            <p class="section-text">
              安全<br />
              上海は一般的に安全ですが、常に注意を払っておくと良いです。明るい場所に留まり、持ち物には注意しましょう。<br /><br />
              交通<br />
              地下鉄は市内を移動するのに最も便利な方法ですが、夜中頃に閉まります。それ以降は、タクシーやDidiなどのライドヘイリングサービスが最適です。<br /><br />
              言語<br />
              ナイトライフ業界の多くの人が英語を話しますが、基本的な中国語のフレーズを知っておくと便利です。翻訳アプリも助けになります。
            </p>

            <p class="footer-text">
              上海のナイトライフシーンは、高エネルギーのクラブからリラックスしたジャズバー、おいしい屋台まで、誰にでも楽しめるものを提供します。ベテラン旅行者でも初めての訪問者でも、このガイドは、この賑やかな街での夜の楽しみ方を最大限に活用するのに役立つはずです。<br /><br />
              上海のナイトライフを体験したことがありますか？
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 19,
    title: "挑戦したいお茶のセレモニー",
    urlinform: "TeaCeremoniestoTry",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Tea%20Ceremonies%20to%20Try/tea-ceremonies1.webp",
    ],
    tags: [
      "茶文化",
      "中国茶道",
      "文化伝統",
      "茶の達人",
      "リラクゼーションの儀式",
    ],
    description:
      "お茶のセレモニーは、何世紀にもわたって人々を魅了し、文化伝統、芸術性、リラクゼーションの融合を提供してきた。これらの儀式は世界各地で進化し、それぞれ独自の慣習と技法を持っている。",
    category: "食べ物",
    nation: "中國",
    body: `
      <div class="container">
            <div class="content">
            <div class="header">
              <h1>挑戦したいお茶のセレモニー</h1>
              <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Tea%20Ceremonies%20to%20Try/1.png"
                  alt="Tea Ceremonies to Try"
                />
              </div>
            <p class="description">
                お茶のセレモニーは、何世紀にもわたって人々を魅了し、文化伝統、芸術性、リラクゼーションの融合を提供してきた。
                これらの儀式は世界各地で進化し、それぞれ独自の慣習と技法を持っている。
                この記事では、挑戦できるさまざまなお茶のセレモニーを、その歴史的なルーツと独特の方法に焦点を当てて探求する。
            </p>
            <h3 class="section-title">中国茶道</h3>
            <p class="section-text">
                中国茶道、別名「工夫茶（Gongfu Cha）」は、世界で最も古く、最も複雑なお茶の儀式の一つ。
                茶葉から最高の風味を引き出し、静かで調和のとれた体験を創り出すことを目指している。
            </p>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Tea%20Ceremonies%20to%20Try/2.png"
                  alt="Tea Ceremonies to Try"
                />
              </div>
            </div>
            <h3 class="section-title">歴史と意義</h3>
            <p class="section-text">
                中国茶道の起源は、唐時代（618-907年）に遡る。
                この時代、お茶を飲むことは、単なる行為から文化的、精神的な体験へと高められた。
                何世紀にもわたって、それは中国の文化の不可欠な部分となり、おもてなし、尊敬、精神的な幸福と結びついている。
                中国人は、お茶のセレモニーが平和の感覚を創り出し、人々をより近くに引き寄せると信じている。<br><br>
                お茶のセレモニーは、歴史的にも年長者や客への尊敬を示すために使用された。
                社会交流、哲学的な議論、さらには政治的な会合の媒体となった。
                儀式は、お茶を飲むことだけでなく、お茶の芸術、香り、味を賞味することでもあった。<br><br>
                現代においても、中国茶道は文化アイデンティティの象徴であり、結婚式や祭りなど、さまざまな祝賀行事の重要な部分である。
                それは、中国茶文化の豊かな遺産を保存し、過去と現在を結ぶ橋として機能している。
            </p>
            <div class="gallery">
                <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Tea%20Ceremonies%20to%20Try/3.png"
                alt="Tea Ceremonies to Try"
              />
                <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Tea%20Ceremonies%20to%20Try/4.png"
                alt="Tea Ceremonies to Try"
              />  
              </div>
            <h3 class="section-title">技法と道具</h3>
            <p class="section-text">
                中国茶道には、小さな急須、茶杯、茶托、茶漉しなど、さまざまな道具が使用される。ここでは、そのプロセスの基本的なガイドを紹介する。<br><br> 
                1. 茶葉の準備：高品質の緩茶葉、多くの場合烏龍茶やプーアル茶が選ばれる。葉は香りと外観を検査して、セレモニーに適しているか確認する。<br><br>
                2. 急須と茶杯の温め：急須と茶杯は熱湯で洗い温める。このステップは、茶葉から最高の風味を引き出すのに重要である。<br><br>
                3. お茶の淹れ：茶葉を急須に入れ、熱湯を注ぐ。最初の淹れは通常「洗い」のために捨てられ、不純物を取り除き、次の淹れに備える。<br><br>
                4. 注ぎとサービス：お茶を再び淹れ、小さな茶杯に注いで提供する。このプロセスは何度も繰り返され、各淹れで異なる風味を提供する。
                この繰り返しの淹れは、工夫茶の独特の特徴であり、お茶を飲む人に茶の進化する味を体験させる。
            </p>
            <h3 class="section-title">茶の種類</h3>
            <p class="section-text">
                中国茶道で使用する茶の選択は、体験に大きく影響を与える。烏龍茶、プーアル茶、緑茶など、異なる茶がそれぞれ独自の風味と香りをセレモニーにもたらす。例えば、烏龍茶は半発酵され、豊かで複雑な風味を提供する一方、緑茶はより繊細で新鮮な味を提供する。
                各種類の茶には、水温や抽出時間など、独自の淹れ方がある。
                これらの微妙な違いを理解することは、工夫茶の達人の一部であり、お茶を飲む体験全体を高める。
            </p>
            <h3 class="section-title">茶道師の役割</h3>
            <p class="section-text">
                伝統的な中国茶道では、茶道師が重要な役割を果たす。茶道師は茶の選択、道具の準備、淹れのプロセスを正確かつ優雅に行う責任がある。彼らの専門知識と知識は、セレモニーを大幅に高め、真に記憶に残る体験にすることができる。<br><br>
                茶道師の動きは慎重で優雅であり、長年の練習と茶の深い理解を反映している。
                彼らの役割は、お茶を提供するだけでなく、静かで尊敬のある環境を創り出すことである。
            </p>
            </div>
        </div>
      `,
  },
  {
    id: 20,
    title: "万里の長城とその先：歴史的遺跡",
    urlinform: "TheGreatWallandBeyondHistoricSites",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/The%20Great%20Wall%20and%20Beyond%20Historic%20Sites/historic-sites1.webp",
    ],
    tags: ["中国", "行き先", "アジア旅行", "中国史", "文化的ランドマーク"],
    description:
      "中国は数千年にわたる豊かで多様な歴史を持つ国。古代の寺院から壮大な宮殿まで、中国の歴史的遺跡は過去を垣間見せ、訪れて体験する価値がある。",
    category: "旅行",
    nation: "中國",
    body: `
      <div class="container">
          <div class="content">
            <div class="header">
              <h1>万里の長城とその先：歴史的遺跡</h1>
              <p class="description">
                中国は数千年にわたる豊かで多様な歴史を持つ国。 
                古代の寺院から壮大な宮殿まで、中国の歴史的遺跡は過去を垣間見せ、訪れて体験する価値がある。 
                旅行リストに追加すべき中国の最も象徴的な歴史的遺跡をいくつか探求しよう。
              </p>
              <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/The%20Great%20Wall%20and%20Beyond%20Historic%20Sites/1.png"
                  alt="The Great Wall and Beyond: Historic Sites"
                />
              </div>
              <h3 class="section-title">万里の長城</h3>
              <p class="section-text">
                万里の長城は世界で最も有名なランドマークの一つ。13,000マイル以上に及ぶこの古代の防御工事は、侵略から守るために建設された。 
                長城を歩くと、田舎の素晴らしい景色と地域の広大な歴史を感じることができる。 
                八達嶺や慕田峪など、長城の異なる部分はよく保存されており、訪問者にとってアクセスしやすい。
              </p>
            </div>
            <h3 class="section-title">故宮</h3>
            <p class="section-text">
                北京の中心部に位置する故宮は、明と清の王朝の帝宮であった。 
                世界最大の古代宮殿構造で、180エーカーに及ぶ。 
                宮殿群は、壮大なホール、美しい庭園、精巧な彫刻で、中国の伝統的な建築の驚異である。 訪問者は様々なホールを探索し、かつてそこに住んでいた皇帝たちの生活について学ぶことができる。
            </p>
            <h3 class="section-title">頤和園</h3>
              <div class="gallery">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/The%20Great%20Wall%20and%20Beyond%20Historic%20Sites/2.png"
                  alt="The Great Wall and Beyond: Historic Sites"
                />
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/The%20Great%20Wall%20and%20Beyond%20Historic%20Sites/5.png"
                  alt="The Great Wall and Beyond: Historic Sites"
                />
            </div>
            <p class="section-text">
                北京の頤和園は、中国の庭園デザインと建築の素晴らしい例である。 
                この広大な複合施設は、清の皇帝たちの夏の避暑地として使用された。 宮殿は昆明湖を中心に配置され、美しい亭、橋、寺院を特徴としている。 湖でのボート乗りは、景色を楽しみ、周囲の静かな美しさを味わうのにリラックスした方法を提供する。
            </p>
            <h3 class="section-title">天坛</h3>
            <p class="section-text">
              北京の天坛は、皇帝たちが豊作を祈るために使用したもう一つの必見の歴史的遺跡。 
              豊作祈願のホールは、円形のデザインと精巧な細部で最も象徴的な建物。 
              周辺の公園は、散歩し、伝統的な中国の景観デザインを楽しむのに平和な場所である。
            </p>
             <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/The%20Great%20Wall%20and%20Beyond%20Historic%20Sites/4.png"
                  alt="The Great Wall and Beyond: Historic Sites"
                />
             </div>
            <h3 class="section-title">兵馬俑</h3>
            <p class="section-text">
                1974年に発見された兵馬俑は、中国初代皇帝の秦始皇の軍隊を描いた実物大の彫刻の集合体。 
                西安に位置するこの考古学遺跡は、20世紀の最も重要な発見の一つ。 
                遺跡は数千人の兵士で構成され、それぞれが独特の顔の表情と鎧を持ち、古代中国の軍事史に魅力的な洞察を提供する。
            </p>
              <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/The%20Great%20Wall%20and%20Beyond%20Historic%20Sites/3.png"
                  alt="The Great Wall and Beyond: Historic Sites"
                />
              </div>
            <h3 class="section-title">ポタラ宮</h3>
            <p class="section-text">
                チベットのラサに位置するポタラ宮は、チベット仏教の象徴であり、ダライ·ラマの冬の住居であった。 
                赤山に位置し、宮殿は13階建てで1,000室以上を含む。 その印象的な建築と豊かな歴史は、チベットを旅行する人にとって必見の場所。<br><br>
                中国の歴史的遺跡は、見るだけの場所ではない。 それらは歴史を生き生きと感じさせる体験である。 
                万里の長城を歩いたり、兵馬俑に感嘆したりすると、これらの遺跡は中国の豊かな文化遺産と深いつながりを提供する。
            </p>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/The%20Great%20Wall%20and%20Beyond%20Historic%20Sites/6.png"
                  alt="The Great Wall and Beyond: Historic Sites"
                />
              </div>
            <p class="footer-text">
                旅行を計画中？忘れられない体験のために、これらの象徴的な遺跡を旅程に必ず含めてください。
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 21,
    title: "東京の夜：最高の夕方スポット",
    urlinform: "TokyoNightsBestEveningSpots",
    css: `${detailPageCss1}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Tokyo%20Nights%20Best%20Evening%20Spots/tokyo-nights4.webp",
    ],
    tags: ["日本ナイトライフ", "夜景", "発見", "東京の街並み", "行き先"],
    description:
      "東京は眠らない街。日が暮れると、街は活気に満ちたナイトライフで賑わう。隠れたスポットを探している旅行者でも、単にどこに行くか迷っている人でも、東京は誰にでも何かを提供している。",
    category: "旅行",
    nation: "日本",
    body: `
      <div class="container">
          <div class="content">
            <div class="header">
              <h1>東京の夜：最高の夕方スポット</h1>
              <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Tokyo%20Nights%20Best%20Evening%20Spots/1.png"
                  alt="Tokyo Nights: Best Evening Spots"
                />
              </div>
            <p class="description">
                東京は眠らない街。日が暮れると、街は活気に満ちたナイトライフで賑わう。
                隠れたスポットを探している旅行者でも、単にどこに行くか迷っている人でも、東京は誰にでも何かを提供している。 
                ここでは、東京で探索するべき最高の夕方スポットをいくつか紹介する。            
            </p>
            <h3 class="section-title">新宿ゴールデン街</h3>
            <p class="section-text">
                新宿のゴールデン街は、東京のナイトライフを体験したい人にとっては必見のスポット。 
                この地区は狭い路地と小さなバーで有名。 
                各バーには独自のテーマがあり、多くのバーは数人しか入れないほど小さい。 
                地元の人や他の旅行者と出会うのに最適な場所。 
                雰囲気は居心地が良く、歓迎されており、旅行者にとって完璧な隠れたスポットとなっている。            
            </p>
            <h3 class="section-title">渋谷スクランブル交差点</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Tokyo%20Nights%20Best%20Evening%20Spots/2.png"
                  alt="Tokyo Nights: Best Evening Spots"
                />
              </div>
            <p class="section-text">
                渋谷スクランブル交差点は、特に夜に東京で最も有名なスポットの一つ。 
                巨大な交差点には各方面から人が渡ってくる。 
                活気に満ちたエネルギーと興奮に満ちた場所。交差点の周辺には数多くのショップ、レストラン、バーがある。 
                何時間も探索し、活気に満ちた雰囲気に浸ることができる。            
            </p>
            <h3 class="section-title">六本木ヒルズ</h3>
            <p class="section-text">
                六本木ヒルズは、高級なナイトライフで知られている。この地区には高級バー、クラブ、レストランが揃っている。 
                森美術館と東京シティビュー展望台もここにある。 
                展望台からは、夜の東京の素晴らしい景色を眺めることができる。 
                もっと洗練された夕方を過ごす場所を探しているなら、六本木ヒルズがおすすめ。            
            </p>
            <h3 class="section-title">思い出横丁</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Tokyo%20Nights%20Best%20Evening%20Spots/3.png"
                  alt="Tokyo Nights: Best Evening Spots"
                />
              </div>
            <p class="section-text">
                思い出横丁、別名「メモリーレーン」は、旅行者にとってもう一つの隠れたスポット。 
                新宿駅近くに位置するこの路地は、小さなレストランやバーでいっぱい。 
                雰囲気は懐かしく、多くの店舗は第二次世界大戦後に建てられた。 
                地元の人と交流しながら、美味しい焼き鳥（鶏の串焼き）やその他の地元料理を楽しむことができる。            
            </p>
            <h3 class="section-title">夜の浅草</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Tokyo%20Nights%20Best%20Evening%20Spots/4.png"
                  alt="Tokyo Nights: Best Evening Spots"
                />
              </div>
            <p class="section-text">
                浅草は歴史的なスポットで知られているが、独特のナイトライフ体験も提供している。 
                浅草寺周辺は夜に美しくライトアップされる。 
                のんびりと散歩し、静かな雰囲気を楽しむことができる。 
                地元の日本酒や料理を味わえる多くの伝統的な居酒屋もある。 
                夜の浅草は、より静かで伝統的な体験を求めている人に最適。            
            </p>
            <h3 class="section-title">お台場</h3>
            <p class="section-text">
                お台場は東京湾にある人工島で、さまざまなエンターテインメントオプションを提供している。 
                この地区は特に夜に美しく、レインボーブリッジと東京タワーの素晴らしい景色を眺めることができる。 
                お台場海浜公園を訪れたり、観覧車に乗ったり、多くのショッピングモールやエンターテインメントコンプレックスを探索したりすることができる。 
                お台場は、夜の東京の景色を楽しみながらリラックスするのに最適な場所。            
            </p>
            <p class="footer-text">
                これらの夕方スポットを探索することで、東京が提供する多様で刺激的なナイトライフの一端を味わうことができる。 
                隠れた宝石を探している人でも、人気のある観光地を探している人でも、東京のナイトライフは誰にでも何かを提供している。<br><br>
                東京のナイトライフに飛び込む準備はできたか？ 
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 22,
    title: "中国の伝統的旅館から近代的ホテルまで",
    urlinform: "TraditionalInnstoModernHotelsinChina",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Traditional%20Inns%20to%20Modern%20Hotels%20in%20China/china-hotel1.webp",
    ],
    tags: [
      "文化的宿泊",
      "ユニークな旅館",
      "宿泊ガイド",
      "旅行宿泊",
      "快適な避難所",
    ],
    description:
      "中国のホスピタリティの景観は、その文化や歴史と同じくらい多様。魅力的な伝統的旅館から洗練された近代的ホテルまで、旅行者には幅広い選択肢がある。",
    category: "ホテル",
    nation: "中國",
    body: `
      <div class="container">
          <div class="content">
            <div class="header">
              <h1>中国の伝統的旅館から近代的ホテルまで</h1>
            <p class="description">
                中国のホスピタリティの景観は、その文化や歴史と同じくらい多様。 
                魅力的な伝統的旅館から洗練された近代的ホテルまで、旅行者には幅広い選択肢がある。
                このガイドは、中国旅行に最適な宿泊施設を探索するのに役立つ。
            </p>
            <div class="image-container">
                <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Traditional%20Inns%20to%20Modern%20Hotels%20in%20China/1.png"
                alt="Traditional Inns to Modern Hotels in China"
              />
            </div>
            <h3 class="section-title">中国の伝統的旅館</h3>
            <p class="section-text">
                「客桟（けさん）」として知られる伝統的旅館は、中国の豊かな文化遺産を垣間見せる。 
                これらの旅館は歴史的建造物に位置し、中庭、木製梁、精巧な彫刻を特徴とする中国の伝統的建築を提供している。
            </p>
            <h3 class="section-title">雰囲気と体験</h3>
            <p class="section-text">
                伝統的旅館に滞在することで、独特で親密な体験ができる。 
                地元の雰囲気を楽しみ、フレンドリーなホストと交流し、本格的な中国料理を味わうことができる。 
                多くの伝統的旅館では、茶道、書道教室、伝統的音楽演奏などの文化活動も提供されている。
            </p>
            <div class="gallery">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Traditional%20Inns%20to%20Modern%20Hotels%20in%20China/2.png"
                  alt="Traditional Inns to Modern Hotels in China"
                />
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Traditional%20Inns%20to%20Modern%20Hotels%20in%20China/3.png"
                  alt="Traditional Inns to Modern Hotels in China"
                />
            </div>
            <h3 class="section-title">立地</h3>
            <p class="section-text">
                伝統的旅館は通常、古い町や景観地区に見られる。人気の目的地には麗江、平遥、大理などがある。これらの場所は、宿泊施設だけでなく、豊かな歴史と文化体験も提供している。
            </p>
            <h3 class="section-title">中国の近代的ホテル</h3>
            <p class="section-text">
                現代的な快適さを好むなら、中国の近代的ホテルは失望させない。 
                これらのホテルは、贅沢な5つ星の施設から予算に優しいオプションまで幅広く、すべての旅行者に何かを提供している。
            </p>
            <h3 class="section-title">設備とサービス</h3>
            <p class="section-text">
                中国の近代的ホテルは、必要なすべての設備が整っている。 
                快適なベッド、Wi-Fi、ルームサービス、フィットネスセンター、時にはプールやスパまで用意されている。これらのホテルの多くは、国際旅行者を支援するために多言語対応のスタッフもいる。
            </p>
            <div class="image-container">
              <img
              src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Traditional%20Inns%20to%20Modern%20Hotels%20in%20China/4.png"
              alt="Traditional Inns to Modern Hotels in China"
              />
            </div>
            <h3 class="section-title">立地</h3>
            <p class="section-text">
                近代的ホテルは、北京、上海、広州などの主要都市で広く利用可能。 
                これらは、ショッピングセンター、ビジネス地区、観光スポットの近くに便利な位置にあることが多く、旅行者が都市を探索しやすくしている。
            </p>
            <h3 class="section-title">宿泊施設の提案</h3>
            <p class="section-text">
                中国で宿泊施設を選ぶ際には、どのような体験を求めているかを考慮しよう。 
                文化的に没入した滞在を求めているのか、それともすべての現代的な便利さを備えた場所を求めているのか？ 
                ここにいくつかの提案がある:<br><br>
                文化的体験のため:<br>
                麗江禅庭ホテル:麗江の旧市街に位置するこの旅館は、美しい伝統的建築で静かな避難所を提供する。<br>
                平遥益徳ホテル:平遥古城の中心にある清王朝の邸宅を復元したホテル。<br><br>
                現代的快適さのため: <br>
                ペニンシュラ北京:北京の王府井地区に位置する、最高級の設備とサービスを備えた贅沢なホテル。<br>
                上海マリオットホテルシティセンター:中央に位置し、サービスと設備が優れており、レジャー旅行者とビジネス旅行者に最適。
            </p>
            <h3 class="section-title">旅行者のガイド</h3>
            <p class="section-text">
                中国旅行を計画する際には、特に観光シーズンのピーク時には、宿泊施設を事前に予約することを忘れないでほしい。また、訪問を計画している場所との位置関係や近接性も考慮しよう。適切な宿泊施設を選ぶことで、旅行体験を向上させ、中国訪問を最大限に活用することができる。
            </p>
            <p class="footer-text">
                中国でユニークな宿泊施設に滞在したことがある？ 
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 23,
    title: "中国の交通ネットワークに関するヒント",
    urlinform: "TransportNetworkTipsforChina",
    css: `${detailPageCss1}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Transport%20Network%20Tips%20for%20China/china-transportation1.webp",
    ],
    tags: [
      "交通のコツ",
      "中国での移動",
      "相乗りオプション",
      "都市内ナビゲーション",
      "公共交通ガイド",
    ],
    description:
      "中国の広大で複雑な交通ネットワークは、初めての旅行者には圧倒されるかもしれない。高速鉄道から地元のバスまで、移動手段は多種多様。",
    category: "ガイド",
    nation: "中國",
    body: `
    <div class="container">
          <div class="content">
            <div class="header">
              <h1>中国の交通ネットワークに関するヒント</h1>
            <p class="description">
                中国の広大で複雑な交通ネットワークは、初めての旅行者には圧倒されるかもしれない。 
                高速鉄道から地元のバスまで、移動手段は多種多様。ここでは、中国の交通ネットワークを効果的かつ経済的に利用するための必須のヒントを紹介する。
            </p>
            <h3 class="section-title">中国の交通ネットワークを理解する</h3>
            <p class="section-text">
                中国の交通ネットワークは多様で広範囲に及ぶ。高速鉄道、地下鉄、バス、タクシー、さらにはシェアバイクも含まれる。各交通手段には利点があり、異なるタイプの旅行に適している。 
                高速鉄道は長距離旅行に最適で、バスや地下鉄は都市内旅行に理想的。このネットワークを理解することで、最適で費用対効果の高い移動手段を選ぶことができる。
            </p>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Transport%20Network%20Tips%20for%20China/1.png"
                  alt="Transport Network Tips for China"
                />
              </div>
            <h3 class="section-title">高速鉄道</h3>
            <p class="section-text">
                中国の高速鉄道システムは世界で最も先進的なものの一つ。北京、上海、広州などの主要都市を結んでいる。これらの鉄道は高速で、時間通り、快適で、長距離旅行に人気の選択肢となっている。特に中国の旧正月や国慶節などの旅行シーズンのピーク時には、事前にチケットを予約することをおすすめする。
            </p>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Transport%20Network%20Tips%20for%20China/2.png"
                  alt="Transport Network Tips for China"
                />
              </div>
            <h3 class="section-title">地下鉄とバス</h3>
            <p class="section-text">
                地下鉄とバスは中国の都市交通の基幹。ほとんどの主要都市には効率的で使いやすい広範囲の地下鉄システムがある。バスも広く利用可能で、地下鉄が通っていない地域にも行くことができる。
            </p>
            <h3 class="section-title">交通費割引のヒント</h3>
            <p class="section-text">
                公共交通を利用する際には、交通カードを取得することを検討しよう。北京や上海などの都市では、地下鉄カードが提供されており、運賃の割引が受けられる。これらのカードは地下鉄とバスの両方で使用可能で、便利な選択肢となっている。さらに、一部のアプリでは相乗りサービスの割引が提供されているため、プロモーションをチェックしよう。
            </p>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Transport%20Network%20Tips%20for%20China/4.png"
                  alt="Transport Network Tips for China"
                />
              </div>
            <h3 class="section-title">タクシーと相乗り</h3>
            <p class="section-text">
                タクシーはほとんどの都市で簡単に利用できるが、他の公共交通手段に比べて高価になる場合がある。滴滴出行（Didi Chuxing）のような相乗りアプリは、より経済的な代替手段を提供している。これらのアプリはUberに似ており、特に中国語を話せない場合には便利な移動手段となる。 
            </p>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Transport%20Network%20Tips%20for%20China/3.png"
                  alt="Transport Network Tips for China"
                />
              </div>
            <h3 class="section-title">シェアバイク</h3>
            <p class="section-text">
                シェアバイクプログラムは多くの中国都市で人気。モバイク（Mobike）やオーフォ（Ofo）などの会社が、モバイルアプリを通じてレンタルできるバイクを提供している。これは自分のペースで都市を探索するのに最適な方法。バイクのQRコードをスキャンしてロックを解除するだけで、出発できる！
            </p>
            <h3 class="section-title">言語の壁を乗り越える</h3>
            <p class="section-text">
                主要都市では多くの標識やアナウンスが中国語と英語の両方で表示されているが、簡単な中国語のフレーズを知っておくと便利。Google翻訳のようなアプリも非常に役立つ。常に目的地を中国語の文字で書いておき、タクシー運転手に見せたり、道を尋ねたりしよう。
            </p>
            <h3 class="section-title">最後のまとめ</h3>
            <p class="section-text">
                中国の交通ネットワークを利用することは、必ずしも困難ではない。オプションを理解し、事前に計画することで、効率的に旅行し、お金を節約することができる。国中を高速鉄道で旅行したり、バスで都市を探索したりする場合でも、中国の交通費割引と交通ネットワークの利用方法に関するこれらのヒントが、旅程をスムーズにするのに役立つ。
            </p>
            <p class="footer-text">
                中国での移動に関する他に何かヒントはある？ 
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 24,
    title: "インドネシアの交通のヒント",
    urlinform: "TransportTipsforIndonesia",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Transport%20Tips%20for%20Indonesia/indonesia-transportation1.webp",
    ],
    tags: [
      "旅程計画",
      "インドネシアのナビゲーション",
      "スマート旅行",
      "公共交通のヒント",
      "空港送迎ガイド",
    ],
    description:
      "インドネシアでの旅行は刺激的な冒険となるが、準備が整っていないと移動に困惑することもある。このガイドでは、空港からどの島や都市中心部へも簡単に移動するための必須の交通のヒントを提供する。",
    category: "ガイド",
    nation: "インドネシア",
    body: `
    <div class="container">
          <div class="content">
            <div class="header">
              <h1>インドネシアの交通のヒント</h1>
            <p class="description">
                インドネシアでの旅行は刺激的な冒険となるが、準備が整っていないと移動に困惑することもある。このガイドでは、空港からどの島や都市中心部へも簡単に移動するための必須の交通のヒントを提供する。
            </p>
            <h3 class="section-title">オプションを理解する</h3>
            <p class="section-text">
                インドネシアでは、異なる予算や好みに合わせた様々な交通手段が提供されている。タクシーやバスから電車やフェリーまで、利用可能な手段を知ることで旅程をスムーズにできる。
            </p>
            <h3 class="section-title">タクシーとライドヘイリングサービス</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Transport%20Tips%20for%20Indonesia/1.png"
                  alt="Transport Tips for Indonesia"
                />
              </div>
            <p class="section-text">
                タクシーは、特に荷物が多い場合に便利なオプション。空港で公式のタクシー乗り場を探して、詐欺を避けよう。さらに、GojekやGrabなどのライドヘイリングアプリは人気があり、従来のタクシーよりも安い場合が多い。到着前にこれらのアプリをダウンロードしておくことを確認しよう。
            </p>
            <h3 class="section-title">公共交通</h3>
            <div class="gallery">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Transport%20Tips%20for%20Indonesia/2.png"
                  alt="Transport Tips for Indonesia"
                />
                <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Transport%20Tips%20for%20Indonesia/3.png"
                alt="Transport Tips for Indonesia"
              />
              </div>
            <p class="section-text">
                公共交通はインドネシアを旅行するのに手頃な方法。以下にいくつかのオプションを紹介する:<br><br>
                バス<br>
                バスは広く利用可能で安価。ただし、混雑している場合があり、時間通りに走らないこともある。TransJakartaとTransJogjaは、ジャカルタとジョグジャカルタでそれぞれ信頼性の高いバスシステム。<br><br>
                電車<br>
                長距離の場合、電車は快適で景色の良いオプション。鉄道網は主にジャワ島とスマトラ島の主要都市を結んでいる。公式ウェブサイトや駅で事前にチケットを予約しよう。<br><br>
                フェリーサービス<br>
                インドネシアは島国なので、島を巡るにはフェリーが不可欠。Pelniなどの主要フェリー運航会社は、様々な島を結ぶ航路を提供している。スケジュールを確認し、特に旅行シーズンのピーク時には事前にチケットを予約することを忘れないでほしい。
            </p>
            <h3 class="section-title">空港から都市中心部へ</h3>
            <div class="image-container">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Transport%20Tips%20for%20Indonesia/4.png"
                  alt="Transport Tips for Indonesia"
                />
              </div>
            <p class="section-text">
                空港から都市中心部への移動は大変に思えるかもしれないが、これらのヒントがスムーズな移行を助ける。<br><br>
                ジャカルタ·スカルノ·ハッタ国際空港<br>
                スカルノ·ハッタ国際空港からは、ジャカルタ市街地への空港鉄道リンクを利用できる。電車は速く、手頃で、渋滞を避けることができる。また、タクシーやライドヘイリングサービスも利用できるが、渋滞に巻き込まれる可能性があることを覚悟しよう。<br><br> 
                ングラライ国際空港（バリ）<br>
                バリのングラライ国際空港は、人気の観光地に近い。タクシーが最も便利なオプションで、公平な価格を保証する固定運賃システムがある。ライドヘイリングサービスも利用可能だが、ピックアップ場所に制限がある場合がある。 
            </p>
            <h3 class="section-title">車両のレンタル</h3>
            <p class="section-text">
                車やスクーターのレンタルは、自分のペースで探索する自由を与える。ただし、インドネシアでの運転は交通状況や道路状況で難しい場合がある。国際運転免許証を持っていることを確認し、道路上で注意しよう。
            </p>
            <h3 class="section-title">最後のまとめ</h3>
            <p class="section-text">
                事前に計画し、オプションを知っていれば、インドネシアでの旅行はストレスフリーにできる。タクシー、公共交通、フェリーなど、どのオプションを選んでも、これらのヴントが自信を持って旅程を進めるのに役立つ。
            </p>
            <p class="footer-text">
                以前にインドネシアを旅行したことがある？  
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 25,
    title: "日本の文化宝を解き明かす",
    urlinform: "UnveilingJapansCulturalTreasures",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Unveiling%20Japan%27s%20Cultural%20Treasures/japanese-culture1.webp",
    ],
    tags: [
      "アート遺産",
      "美術館",
      "日本のアート",
      "アクティビティ",
      "日本の美学",
    ],
    description:
      "日本のアートシーンは、歴史、文化、美しさの豊かな織物。伝統的な日本画（Nihonga）から魅惑的な浮世絵（ukiyo-e）版画まで、日本のアートはその魂に独特の視点を提供する。",
    category: "旅行",
    nation: "日本",
    body: `
    <div class="container">
          <div class="content">
            <div class="header">
              <h1>日本の文化宝を解き明かす</h1>
            <p class="description">
                日本のアートシーンは、歴史、文化、美しさの豊かな織物。 
                伝統的な日本画（Nihonga）から魅惑的な浮世絵（ukiyo-e）版画まで、日本のアートはその魂に独特の視点を提供する。 
                この記事では、日本画と浮世絵を含む日本の最も貴重なアート形式を探索する。            
            </p>
            <h3 class="section-title">日本画：伝統的な日本の絵画</h3>
            <div class="gallery">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Unveiling%20Japan%27s%20Cultural%20Treasures/1.png"
                  alt="Unveiling Japan's Cultural Treasures"
                />
                <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Unveiling%20Japan%27s%20Cultural%20Treasures/2.png"
                alt="Unveiling Japan's Cultural Treasures"
              />
              </div>
            <p class="section-text">
                日本画（Nihonga）は、19世紀後半にさかのぼる伝統的なアート形式で、「日本式絵画」を意味する。 
                このスタイルは、鉱物、貝殻、さらには半宝石から作られた天然顔料を取り入れている。 
                材料は細かい粉末に研磨され、動物の接着剤と混合して鮮やかな色を作り出す。<br><br>
                日本画の特徴<br>
                日本画は繊細な線と微妙な色使いで知られる。 
                アーティストは、花、動物、風景などの自然を描くことが多く、歴史や神話のテーマも描く。 
                絵画は通常、和紙（日本紙）や絹に描かれ、作品に独特の質感を加える。
            </p>
            <h3 class="section-title">浮世絵：浮き世の絵</h3>
            <div class="gallery">
                <img
                  src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Unveiling%20Japan%27s%20Cultural%20Treasures/3.png"
                  alt="Unveiling Japan's Cultural Treasures"
                />
                <img
                src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Unveiling%20Japan%27s%20Cultural%20Treasures/4.png"
                alt="Unveiling Japan's Cultural Treasures"
              />
              </div>
            <p class="section-text">
                浮世絵（ukiyo-e）は、「浮き世の絵」を意味し、もう一つの象徴的な日本のアート形式。このスタイルは江戸時代（1603-1868）に登場し、木版画で広く人気を博した。 
                浮世絵のアーティストは、歌舞伎役者、相撲力士、美しい風景など、日常生活の場面に焦点を当てた。<br><br>
                有名な浮世絵アーティスト<br>
                最も有名な浮世絵アーティストには、葛飾北斎と歌川広重がいる。 
                北斎の「神奈川沖浪裏」は、世界中で最も認知度の高い日本のアート作品の一つ。 
                一方、広重は、「東海道五十三次」シリーズで知られ、日本の風景の美しさを捉えている。
            </p>
            <h3 class="section-title">日本のアートが世界に与えた影響</h3>
            <p class="section-text">
                日本のアートは、世界的なアート運動に大きな影響を与えた。 
                日本画と浮世絵の遠近法、大胆な色使い、精巧な細部描写は、多くの西洋のアーティストに影響を与えた。 
                ヴィンセント·ヴァン·ゴッホやクロード·モネなどの印象派画家は、日本の版画に特に魅了され、自分の作品にこれらの要素を取り入れた。            
            </p>
            <h3 class="section-title">日本の文化宝の保存</h3>
            <p class="section-text">
                日本の文化宝の保存に向けた努力は続いている。 
                国内の美術館、ギャラリー、文化機関は、これらの貴重な作品を展示し、保護することに専念している。 
                展覧会では、歴史的作品と現代の解釈の両方を特集し、訪問者に日本のアートの進化を理解してもらう。
            </p>
            <h3 class="section-title">日本のアートを直接体験</h3>
            <p class="section-text">
                日本の文化宝を直接体験したいなら、国内の有名な美術館を訪れることを検討しよう。 
                東京国立博物館、京都国立博物館、足立美術館は、始めるのに最適な場所。 
                これらの機関では、日本画、浮世絵、その他の伝統的な日本のアート形式の世界を深く掘り下げることができる。            
            </p>
            <p class="footer-text">
                日本の豊かなアート遺産を探索することで、その歴史、文化、形作ってきた芸術的表現を深く理解できる。 
                アート愛好家でも、カジュアルな観察者でも、日本の文化宝は確実に深い印象を残す。<br><br>
                日本のアートを探索したことはある？ <br>
            </p>
          </div>
        </div>
      `,
  },
  {
    id: 26,
    title: "中国の歌劇に注目",
    urlinform: "WatchOuttotheChineseOpera",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/watch%20out%20to%20the%20chinese%20opera/chinese-opera1.webp",
    ],
    tags: [
      "中国歌劇",
      "中国での体験",
      "行き先",
      "歌劇の仮面とメイク",
      "伝統的な演劇",
    ],
    description:
      "中国歌劇は、音楽、歌唱、パントマイム、ダンス、曲芸を組み合わせた魅力的で古代の演劇形式。多くのスタイルの中で、北京歌劇はその豊かな歴史と活気に満ちたパフォーマンスで際立っている。",
    category: "旅行",
    nation: "中國",
    body: `
        <div class="container">
      <div class="content">
        <div class="header">
          <h1>中国の歌劇に注目</h1>
          <div class="image-container">
            <img
              src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/watch%20out%20to%20the%20chinese%20opera/1.png"
              alt="Watch Out to the Chinese Opera"
            />
          </div>
          <p class="description">
            中国歌劇は、音楽、歌唱、パントマイム、ダンス、曲芸を組み合わせた魅力的で古代の演劇形式。多くのスタイルの中で、北京歌劇はその豊かな歴史と活気に満ちたパフォーマンスで際立っている。この記事では、中国歌劇の魅力的な世界を紹介し、特に象徴的な北京歌劇の仮面と、これらのパフォーマンスで重要な役割を果たす顔面メイクに焦点を当てる。
          </p>
          <h3 class="section-title">中国歌劇の歴史</h3>
          <p class="section-text">
            中国歌劇は千年以上も前から存在し、様々な王朝や文化の変遷を経て進化してきた。当初は王宮で上演されていたが、次第に一般市民にも広まり、中国文化の不可欠な一部となった。北京歌劇、別名京劇は、18世紀後半に登場し、すぐに人気を博した。
          </p>
          <div class="gallery">
            <img
              src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/watch%20out%20to%20the%20chinese%20opera/2.png"
              alt="Watch Out to the Chinese Opera"
            />
            <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/watch%20out%20to%20the%20chinese%20opera/4.png"
            alt="Watch Out to the Chinese Opera"
            />
          </div>
        </div>
        <h3 class="section-title">仮面とメイクの重要性</h3>
        <p class="section-text">
            北京歌劇の仮面<br>
            北京歌劇の仮面は単なる装飾品ではなく、物語を伝えるプロセスに不可欠。これらの仮面は鮮やかで多彩で、それぞれ異なるキャラクターや感情を表現するようにデザインされている。伝統的に、仮面は勇敢さ、忠誠心、悪役などの特徴を表すのに使用される。例えば、赤い仮面は忠誠心と勇敢さを表すキャラクターを表し、白い仮面は裏切りと狡猾さを表す。<br><br>
            中国京劇の顔面メイク<br>
            中国京劇の顔面メイクは、それ自体が一つのアート形式。パフォーマーは何時間もかけて、自分の役割を強調する精巧なデザインを施す。メイクはランダムではなく、特定のパターンと色に従って、キャラクターの年齢、職業、性格を伝える。このプロセスには、白いペイントのベース層があり、その上に大胆な色とデザインが施され、キャラクターが舞台上で生き生きと現れる。
        </p>
        <div class="image-container">
             <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/watch%20out%20to%20the%20chinese%20opera/3.png"
            alt="Watch Out to the Chinese Opera"
            />
        </div>
        <h3 class="section-title">中国歌劇パフォーマンスの要素</h3>
        <p class="section-text">
            音楽と楽器<br>
            音楽は中国歌劇で重要な役割を果たし、パフォーマンスを導き、雰囲気を設定する。二胡、琵琶、鉦などの伝統的な中国楽器がよく使用される。音楽は常に速くて活気に満ちており、パフォーマーのダイナミックな動きを補完する。<br><br>
            衣装と小道具<br>
            中国歌劇の衣装は精巧で多彩で、しばしばシルクで作られ、精巧な刺繍で飾られている。これらの衣装はキャラクターの社会的地位、職業、性格を定義するのに役立つ。剣、扇子、旗などの小道具も物語を強化するために使用される。
        </p>
        <h3 class="section-title">現代の影響と世界的な普及</h3>
        <p class="section-text">
            中国歌劇、特に北京歌劇は、中国に留まらず、世界中の様々な演劇形式に影響を与え、数多くの国際フェスティバルのテーマとなっている。西洋劇場との現代的な改編やコラボレーションにより、この古代のアート形式を生き生きと関連性のあるものに保つのに役立っている。
        </p>
        <p class="section-text">
            中国歌劇は、魅惑的な仮面、精巧なメイク、ダイナミックなパフォーマンスで、中国の豊かな文化遺産に独特の視点を提供する。ベテランのファンでも、好奇心旺盛な新参者でも、中国歌劇のパフォーマンスを観ることは忘れられない体験となる。次の機会があったら、この魅力的なアート形式を見逃さないでほしい。
        </p>
        <p class="footer-text">
            中国歌劇のパフォーマンスを観たことはある？ 
        </p>
      </div>
    </div>
      `,
  },

  {
    id: 27,
    title: "アドベンチャー：ハイキング、サーフィン、その他",
    urlinform: "AdventureHikingSurfingandMore",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Adventure%20Hiking,%20Surfing,%20and%20More/adventure-travel1.webp",
    ],
    tags: [
      "インドネシアのハイキングコース",
      "アドベンチャー好き",
      "アウトドアアドベンチャー",
      "文化探訪",
      "絶景スポット",
    ],
    description:
      "インドネシアはアドベンチャー好きの楽園。多様な景観と豊かな文化で、多くの刺激的な活動を提供している。ハイキング、サーフィン、探検など、インドネシアは誰にでも何かを提供している。",
    category: "旅行",
    nation: "インドネシア",
    body: `
        <div class="container">
      <div class="content">
        <div class="header">
          <h1>アドベンチャー：ハイキング、サーフィン、その他</h1>
        <p class="description">
            インドネシアはアドベンチャー好きの楽園。多様な景観と豊かな文化で、多くの刺激的な活動を提供している。 ハイキング、サーフィン、探検など、インドネシアは誰にでも何かを提供している。このガイドでは、いくつかのトップアドベンチャー活動とその価格を見ていく。
        </p>
        <h3 class="section-title">ハイキング</h3>
        <div class="image-container">
          <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Adventure%20Hiking,%20Surfing,%20and%20More/1.png"
            alt="Adventure: Hiking, Surfing, and More"
          />
        </div>
        <p class="section-text">
            人気のハイキングスポット<br><br>
            インドネシアの自然美を体験する最良の方法の一つはハイキング。人気のスポットにはブロモ山、リンジャニ山、イジェンクレーターがある。それぞれが独特の景色とすべてのレベルのハイカーにとっての挑戦を提供する。<br><br>
            - ブロモ山：この活火山は、壮大な日の出の景色で有名。<br>
            - リンジャニ山：ロンボク島に位置し、このハイキングは息をのむような景色とクレーター湖を見る機会を提供する。<br>
            - イジェンクレーター：青い炎で知られ、これはあなたが体験できる最もユニークなハイキングの一つ。<br>
            ハイキングの費用<br>
            インドネシアでのハイキングの価格は場所やガイドによって異なる。一般的に、ガイド付きツアーには30ドルから100ドルの間で支払うことが期待できる。これには往復交通費、ガイド、時々食事が含まれる。  
        </p>
        <h3 class="section-title">サーフィン</h3>
        <div class="image-container">
          <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Adventure%20Hiking,%20Surfing,%20and%20More/2.png"
            alt="Adventure: Hiking, Surfing, and More"
          />
        </div>
        <p class="section-text">
            最高のサーフィンスポット<br><br>
            インドネシアはサーファーにとってのトップデスティネーション。温暖な海水と安定した波で、初心者にもプロにも最適。最高のスポットにはバリ、メンタワイ諸島、Gランドがある。<br>
            - バリ：世界的に有名な波で、サーファーの夢。<br>
            - メンタワイ諸島：これらの島は世界で最高のサーフブレイクをいくつか提供している。<br>
            - Gランド：東ジャワに位置し、Gランドは長くて強力な波で有名。<br>
            サーフィンの費用<br>
            インドネシアでのサーフィンの費用は、器材レンタルやレッスンによって異なる。サーフボードのレンタルは1日当たり約5ドルから10ドル。サーフィンレッスンは通常、インストラクターや場所によってセッション当たり20ドルから50ドル。 
        </p>
        <h3 class="section-title">その他のアドベンチャー活動</h3>
        <div class="gallery">
          <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Adventure%20Hiking,%20Surfing,%20and%20More/3.png"
            alt="Adventure: Hiking, Surfing, and More"
          />
          <img
          src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Adventure%20Hiking,%20Surfing,%20and%20More/4.png"
          alt="Adventure: Hiking, Surfing, and More"
        />
        </div>
        <p class="section-text">
            スキューバダイビング<br>
            インドネシアはスキューバダイビングにも最適。海水は透明で、海洋生物は多様。人気のダイビングスポットにはラジャアンパット、コモド島、バリがある。<br>
            スキューバダイビングの費用<br>
            1ダイブの価格は30ドルから50ドル。資格を取得したい場合、コースは通常300ドルからスタート。<br><br>
            ロッククライミング<br>
            ロッククライミングが好きな人には、インドネシアには素晴らしいスポットがある。バリやロンボクなどの地域はすべてのスキルレベルに登るルートを提供している。<br><br>
            ロッククライミングの費用<br>
            ロッククライミングの価格は様々。ガイド付きクライミングツアーは通常1日当たり50ドルから100ドル。これには器材とガイドが含まれる。 
        </p>
        <h3 class="section-title">旅行者ガイド</h3>
        <p class="section-text">
            インドネシアへのアドベンチャー旅行を計画する際には、事前に活動を予約することを検討しよう。これにより、お金を節約し、予約確保ができる。また、現地の習慣や安全上のヒントを調べて、旅行を楽しく安全に過ごそう。
        </p>
        <p class="footer-text">
            要するに、インドネシアはあらゆるタイプの旅行者に幅広いアドベンチャー活動を提供している。ハイキングやサーフィンからスキューバダイビングやロッククライミングまで、誰にでも何かがある。正しい計画を立てれば、お金を使いすぎることなく忘れられないアドベンチャーを体験できる。<br><br>
            インドネシアでこれらの活動を試したことがある？ 
        </p>
      </div>
    </div>
      `,
  },
  {
    id: 28,
    title: "宿泊先：リゾートからホームステイまで",
    urlinform: "WhereToStayResortsToHomestays",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Where%20to%20Stay%20Resorts%20to%20Homestays/resort3.webp",
    ],
    tags: [
      "文化ホームステイ",
      "ヴィラの提案",
      "予算重視の宿泊",
      "豪華な体験",
      "家族向けの宿泊",
    ],
    description:
      "バリ島での宿泊先を選ぶことは、ワクワクと困惑の両方を伴う。この島は、豪華なリゾートから居心地の良いホームステイまで、幅広い宿泊施設を提供している。",
    category: "ホテル",
    nation: "インドネシア",
    body: `
       <div class="container">
      <div class="content">
        <div class="header">
          <h1>宿泊先：リゾートからホームステイまで</h1>
          <div class="image-container">
            <img
              src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Where%20to%20Stay%20Resorts%20to%20Homestays/1.png"
              alt="Where to Stay: Resorts to Homestays"
            />
          </div>
        <p class="description">
            バリ島での宿泊先を選ぶことは、ワクワクと困惑の両方を伴う。 この島は、豪華なリゾートから居心地の良いホームステイまで、幅広い宿泊施設を提供している。贅沢なリトリートを探しているのか、予算に優しいオプションを探しているのかに関係なく、誰にでも何かがある。このバリ旅行者ブログガイドでは、バリ島のさまざまな宿泊施設の選択肢を探索し、旅行に最適な決定をするのに役立てる。          
        </p>
        <h3 class="section-title">リゾート</h3>
        <div class="image-container">
          <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Where%20to%20Stay%20Resorts%20to%20Homestays/2.png"
            alt="Where to Stay: Resorts to Homestays"
          />
        </div>
        <p class="section-text">
            バリ島のリゾートは、贅沢とリラックスを求める人に最適。ほとんどのリゾートはビーチ近くに位置し、素晴らしい景色、世界クラスの設備、卓越したサービスを提供している。多くのリゾートにはプライベートプール、スパ、高級レストラン、さまざまなレクリエーション活動が付いている。自分を甘やかして、心配のない休暇を楽しみたいなら、リゾートが最適な選択肢かもしれない。
        </p>
        <h3 class="section-title">人気のリゾートエリア</h3>
        <p class="section-text">
            - ヌサドゥア：高級リゾートと美しいビーチで知られる。<br>
            - セミニャック：贅沢と活気に満ちたナイトライフの両方を提供。<br>
            - ウブド：豊かな緑と文化的なアトラクションに囲まれている。
        </p>
        <h3 class="section-title">ホテル</h3>
        <div class="image-container">
          <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Where%20to%20Stay%20Resorts%20to%20Homestays/3.png"
            alt="Where to Stay: Resorts to Homestays"
          />
        </div>
        <p class="section-text">
            バリ島のホテルは、予算に応じた幅広いオプションがある。リゾートとホームステイの中間的な存在で、快適さと便利さを提供している。ホテルは通常、中心部に位置し、地元のアトラクション、レストラン、ショップを簡単に探索できる。多くのホテルは、スイミングプール、ジム、屋内ダイニングなどの設備を提供している。<br><br>
            予算に優しいホテル<br>           
            予算を気にする旅行者には、バリ島にはたくさんの手頃な価格のホテルがある。これらのホテルは、お金を節約しながら、基本的な設備と快適な滞在を提供している。<br>
            - クタ：予算に優しい宿泊施設と活気に満ちた雰囲気で知られる。<br>
            - レギャン：クタに比べてよりリラックスした雰囲気だが、まだたくさんの手頃な価格のオプションがある。         
        </p>
        <h3 class="section-title">ヴィラ</h3>
        <div class="image-container">
          <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Where%20to%20Stay%20Resorts%20to%20Homestays/4.png"
            alt="Where to Stay: Resorts to Homestays"
          />
        </div>
        <p class="section-text">
            ヴィラは、プライバシーと家庭的な雰囲気を求める人に人気の選択肢。家族、グループ、ロマンティックな旅行を求めるカップルに最適。ほとんどのヴィラにはプライベートプール、ガーデン、設備の整ったキッチンが付いている。ヴィラに滞在すれば、自分のペースでバリ島を体験でき、自分で料理を作ったり、自分の空間のプライバシーを楽しんだりできる。
        </p>
        <h3 class="section-title">ホームステイ</h3>
        <p class="section-text">
            ホームステイは、旅行者にユニークで本物の体験を提供する。地元の家族と滞在することで、バリ島の文化を直接体験できる。ホームステイは通常、リゾートやホテルよりも手頃な価格で、よりパーソナルなタッチを提供する。このタイプの宿泊施設は、地元の文化に浸り、地元の人々と意味のあるつながりを作りたい人に最適。<br><br>
            ホームステイの利点<br>
            - 文化浸透：地元の習慣や伝統を学ぶ。<br>
            - 手頃な価格：ホテルやリゾートよりも安いことが多い。<br>
            - パーソナライズドな体験：地元の家族のおもてなしを楽しむ。
        </p>
        <h3 class="section-title">ゲストハウス</h3>
        <p class="section-text">
            ゲストハウスはホームステイに似ているが、通常はより多くのプライバシーと独立性を提供する。通常は家族経営で、居心地の良い家庭的な雰囲気を提供している。ゲストハウスは、ソロ旅行者、カップル、小さなグループにとって、手頃で快適な宿泊施設を探している人に最適。
        </p>
        <p class="footer-text">
            バリ島のさまざまな宿泊施設の選択肢を理解することで、ニーズや予算に合った完璧な宿泊施設を見つけることができる。リゾートの贅沢、ホテルの快適さ、ヴィラのプライバシー、ホームステイの本物の体験など、バリ島は誰にでも何かがある。<br><br>
            以前バリ島に滞在したことがある？ 
        </p>
      </div>
    </div>
      `,
  },
  {
    id: 29,
    title: "日本での宿泊：伝統的 vs. 现代的",
    urlinform: "WheretoStayinJapanTraditionalvsModern",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Where%20to%20Stay%20in%20Japan%20Traditional%20vs.%20Modern/accommodation-japan1.webp",
    ],
    tags: [
      "日本での宿泊",
      "予算に合った宿泊施設",
      "日本のおもてなし",
      "宿泊先",
      "生活ガイド",
    ],
    description:
      "日本は、古い伝統と最先端の現代性が共存する対照的な国。この融合は、旅行者が利用できる宿泊施設の種類に特に顕著に表れている。",
    category: "ホテル",
    nation: "日本",
    body: `
      <div class="container">
      <div class="content">
        <div class="header">
          <h1>日本での宿泊：伝統的 vs. 现代的</h1>
        <p class="description">
            日本は、古い伝統と最先端の現代性が共存する対照的な国。 
            この融合は、旅行者が利用できる宿泊施設の種類に特に顕著に表れている。 
            予算を厳しく制限して旅行を計画しているのか、豪華に散財したいのかに関係なく、日本でどこに滞在するかを知ることで、旅行体験を大きく左右する。 
            この記事では、伝統的な宿泊施設と現代的な宿泊施設の違いを理解するのに役立ち、さまざまな予算の選択肢についてのヒントを提供する。            
        </p>
        <h3 class="section-title">伝統的な宿泊施設</h3>
        <div class="gallery">
            <img
              src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Where%20to%20Stay%20in%20Japan%20Traditional%20vs.%20Modern/1.png"
              alt="Where to Stay in Japan: Traditional vs. Modern"
            />
            <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Where%20to%20Stay%20in%20Japan%20Traditional%20vs.%20Modern/2.png"
            alt="Where to Stay in Japan: Traditional vs. Modern"
          />
          </div>
        <p class="section-text">
            旅館<br>
            旅館に滞在することで、日本文化に独特の視点を得ることができる。これらの伝統的な宿は、畳敷きの部屋、障子、共同浴場を特徴としている。宿泊中は通常、ゆかた（カジュアルな着物）が提供される。食事は通常、会席料理（日本の多コースディナー）で、部屋または共同ダイニングエリアで提供される。<br><br>           
            予算のヒント：旅館は高価になることがあるが、オフピークシーズンにはより手頃な価格の旅館もある。より予算に優しい選択肢として、小規模で家族経営の旅館を探そう。<br><br>           
            民宿<br>
            民宿は家族経営のベッド＆ブレックファストタイプの宿泊施設。旅館よりもより親密で家庭的な体験を提供する。部屋は通常シンプルで、共同バスルームとダイニングエリアがある。食事は通常家庭料理で、地元の食材を使用している。<br><br>           
            予算のヒント：民宿は通常、旅館よりも安価で、似たような伝統的な体験を提供する。日本文化を体験したいが予算に気を使っている旅行者には最適な選択肢。          
        </p>
        <h3 class="section-title">現代的な宿泊施設</h3>
        <div class="image-container">
            <img
              src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Where%20to%20Stay%20in%20Japan%20Traditional%20vs.%20Modern/3.png"
              alt="Where to Stay in Japan: Traditional vs. Modern"
            />
          </div>
        <p class="section-text">
            ホテル<br>
            日本のホテルは、予算に優しいビジネスホテルから豪華な五つ星の施設まで幅広い。ビジネスホテルは、手頃な価格で基本的な設備を求める旅行者向けに、小さく効率的に設計された部屋を提供する。一方、豪華なホテルは広々とした部屋、高級設備、卓越したサービスを提供する。<br><br>           
            予算のヒント：ビジネスホテルは予算を気にする旅行者に最適。Wi-Fiなどの基本的な設備が整った清潔で快適な部屋を提供し、豪華なホテルのほんの一部の価格で提供する。<br><br>            
            カプセルホテル<br>
            カプセルホテルは、短時間滞在向けに設計された日本独自の発明。客は、横に並べられた小さなポッドのようなカプセルで眠る。これらのカプセルには、ベッド、テレビ、時々小さな金庫などの基本的な設備が整っている。カプセルホテルには通常、共同バスルームとラウンジがある。<br><br>            
            予算のヒント：カプセルホテルは日本で最も手頃な価格の選択肢の一つ。ソロ旅行者や、お金を使いすぎることなく、日本独自の体験をしたい人に最適。            
        </p>
        <h3 class="section-title">混合型宿泊施設</h3>
        <div class="image-container">
            <img
              src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Where%20to%20Stay%20in%20Japan%20Traditional%20vs.%20Modern/4.png"
              alt="Where to Stay in Japan: Traditional vs. Modern"
            />
          </div>
        <p class="section-text">
            デザインホテル<br>
            伝統的と现代的な両方を求める旅行者には、両方の世界で最高のものを提供する宿泊施設がある。これらの場所は、伝統的な要素を残した設定で、現代的な設備を特徴としている。例えば、西洋風のベッドがあるが、伝統的な日本の装飾と共同浴場があるホテルを見つけることができる。<br><br>            
            予算のヒント：スタイルの融合を宣伝する中級ホテルやホステルを探そう。これらは合理的な価格でバランスの取れた体験を提供することができる。<br><br>            
        </p>
        <p class="footer-text">
            伝統的な宿の魅力と現代的なホテルの便利さのどちらを好むかに関係なく、日本はさまざまな予算や好みに合わせた幅広い宿泊施設を提供している。利用可能な選択肢を理解することで、旅行体験を高める情報に基づいた決定を下すことができる。<br><br>
            これらのタイプの宿泊施設のどれかに滞在したことがある？             
        </p>
      </div>
    </div>
      `,
  },
  {
    id: 30,
    title: "日本の鉄道システムの完全ガイド",
    urlinform: "AComprehensiveGuidetoJapansRailSystem",
    css: `${detailPageCss1}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/A%20Comprehensive%20Guide%20to%20Japan's%20Rail%20System/railway-system1.webp",
    ],
    tags: [
      "旅行ガイド",
      "鉄道パスのヒント",
      "鉄道網",
      "日本の交通",
      "快適な旅行",
    ],
    description:
      "日本の鉄道システムは世界で最も効率的で信頼性の高いシステムの一つ。観光客でも地元の人でも、正しい情報があれば、この広範なネットワークを簡単に利用することができる。",
    category: "ガイド",
    nation: "日本",
    body: `
      <div class="container">
      <div class="content">
        <div class="header">
          <h1>日本の鉄道システムの完全ガイド</h1>
          <div class="gallery">
            <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/A%20Comprehensive%20Guide%20to%20Japan's%20Rail%20System/1.png"
            alt="A Comprehensive Guide to Japan's Rail System"
            />
            <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/A%20Comprehensive%20Guide%20to%20Japan's%20Rail%20System/3.png"
            alt="A Comprehensive Guide to Japan's Rail System"
            />
            <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/A%20Comprehensive%20Guide%20to%20Japan's%20Rail%20System/4.png"
            alt="A Comprehensive Guide to Japan's Rail System"
            />
          </div>
        <p class="description">
            日本の鉄道システムは世界で最も効率的で信頼性の高いシステムの一つ。 
            観光客でも地元の人でも、正しい情報があれば、この広範なネットワークを簡単に利用することができる。
            このガイドは、日本の鉄道マップ、JRと通常の列車の違いの理解、そして快適な旅行のためのヒントを提供するのに役立つ。            
        </p>
        <h3 class="section-title">日本の鉄道マップの理解</h3>
        <p class="section-text">
            日本の鉄道マップは最初は圧倒的に思えるかもしれないが、小さな区間に分けることで理解しやすくなる。 
            東京、大阪、京都などの主要都市は、路線のネットワークでよく接続されている。 
            これらの路線は色分けされ、番号が付けられており、追いやすい。            
        </p>
        <h3 class="section-title">主要鉄道路線</h3>
        <p class="section-text">
            - 新幹線（弾丸列車）：主要都市を結ぶ高速列車。
            - JR線：日本鉄道が運営し、地方や地域の路線をカバー。
            - 私鉄：これらの路線は民間企業が運営し、地域の地域をサービスしていることが多い。
        </p>
        <h3 class="section-title">日本の列車旅行のヒント</h3>
        <div class="image-container">
          <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/A%20Comprehensive%20Guide%20to%20Japan's%20Rail%20System/2.png"
            alt="A Comprehensive Guide to Japan's Rail System"
          />
        </div>
        <p class="section-text">
            日本で列車で旅行することは便利で快適。 
            旅行をよりスムーズにするためのヒントをいくつか紹介する:<br><br>
            切符の購入<br>
            切符は駅の券売機や窓口で購入できる。 
            観光客には、JR線で一定期間無制限で旅行できる日本鉄道パスがあり、費用対効果の高い選択肢。<br><br>
            駅の案内<br>
            日本の列車駅は、日本語と英語の両方で明確な標識があり、整理されている。 
            ホームには列車名と発車時刻が表示され、正しい列車に乗ることができる。
        </p>
        <h3 class="section-title">JRと通常の列車の違い</h3>
        <p class="section-text">
            効率的な旅行のために、JR（日本鉄道）と通常の列車の違いを理解することが重要。<br><br>
            JR列車<br>
            カバー範囲：JR列車は、地方、地域、高速新幹線を含む広範なエリアをカバー。
            切符：JR線で無制限で旅行するために日本鉄道パスを使用できる。
            駅：JR駅は通常、より多くの設備を備えた大規模な駅。<br><br>
            通常の列車<br>
            カバー範囲：民間企業が運営し、これらの列車は地域や地域をサービスしていることが多い。
            切符：別々の切符が必要で、日本鉄道パスは使用できない。
            駅：これらの駅は小規模で、設備が少ない可能性がある。
        </p>
        <h3 class="section-title">日本鉄道パスの使用</h3>
        <p class="section-text">
            日本鉄道パスは観光客にとって素晴らしい選択肢。JR線、新幹線を含む無制限で旅行できる。 
            日本に到着する前にパスを購入し、JR駅で引き換える必要がある。<br><br>            
            パスの種類<br>
            普通パス：標準クラスの旅行に適している。
            グリーンパス：より快適な旅行のためにファーストクラスの座席を提供。<br><br>
            最終的なヒント<br>
            事前計画：オンラインツールやアプリを使用してルートを計画。
            軽装で旅行：駅には階段があることが多いので、できるだけ軽装で。
            ルールの尊重：列車内で静かにし、順番に並ぶなど、地元の習慣に従う。
        </p>
        <p class="footer-text">
            日本の鉄道システムは、正しい知識があれば簡単に利用できる。 
            賑やかな都市や静かな田舎を探索するのに、鉄道システムは信頼性と効率性の高い旅行方法を提供する。<br><br>            
            安全な旅行を！
        </p>
      </div>
    </div>
      `,
  },

  {
    id: 31,
    title: "日本懐石料理への料理の旅：上品な食事の芸術",
    urlinform: "ACulinaryJourneyintoJapansKaisekiTheArtofFineDining",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/A%20Culinary%20Journey%20into%20Japan%E2%80%99s%20Kaiseki:%20The%20Art%20of%20Fine%20Dining/Japan%E2%80%99s%20Kaiseki2.webp",
    ],
    tags: ["日本", "食べ物", "贅沢", "懐石料理", "寿司", "祝う"],
    description:
      "懐石料理は日本料理の頂点を代表し、単なる食事を超えた洗練された料理体験。京都の茶道の伝統に根ざした懐石料理は、味、食感、見た目、色をバランスさせた多コースの食事に進化した。",
    category: "食べ物",
    nation: "日本",
    body: `
        <div class="container">
      <div class="content">
        <div class="header">
          <h1>
            日本懐石料理への料理の旅：上品な食事の芸術
          </h1>
          <p class="description">
            懐石料理で日本のハウトクイジーンの本質を発見し、季節の食材、繊細な味、芸術的なプレゼンテーションを祝う、絶妙な多コースの食事。
          </p>
        </div>
        <div class="image-container">
          <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/A%20Culinary%20Journey%20into%20Japan%E2%80%99s%20Kaiseki:%20The%20Art%20of%20Fine%20Dining/2.png"
            alt="Introduction to Kaiseki"
          />
        </div>
        <h3 class="section-title">
          懐石料理とは何か？味と美学のエレガンスの交响曲
        </h3>
        <p class="section-text">
          懐石料理は日本料理の頂点を代表し、単なる食事を超えた洗練された料理体験。京都の茶道の伝統に根ざした懐石料理は、味、食感、見た目、色をバランスさせた多コースの食事に進化した。すべての料理は、季節の食材の自然な味を尊重しながら、シェフの芸術性を展示するために、緻密な注意を払って作られている。この食事スタイルは、食べ物と環境、食材と季節、そして食事者自身の間の調和を強調する。各コースは軽い前菜から始まり、スープ、刺身、焼き物、蒸し物、デザートを経て、慎重に配慮された順序で提供される。懐石料理は食事以上のもの；それは感覚的な旅である。
        </p>
        <div class="image-container">
          <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/A%20Culinary%20Journey%20into%20Japan%E2%80%99s%20Kaiseki:%20The%20Art%20of%20Fine%20Dining/1.png"
            alt="Philosophy of Kaiseki"
          />
        </div>
        <h3 class="section-title">懐石料理の背後にある芸術と哲学</h3>
        <p class="section-text">
          懐石料理の中心には、日本の自然の季節と、簡素さと不完全さの中に美を見出す文化哲学の侘寂（わびさび）への深い敬意がある。懐石料理の料理は、自然の儚い美しさを強調するために慎重に準備されている。例えば、春の懐石料理のメニューには桜の花が飾りとして登場し、秋のメニューにはキノコや鮮やかな紅葉の葉が取り入れられる。各コースは、料理の色や質感を補完するように慎重に選ばれた伝統的な日本の陶器、漆器、竹皿に盛り付けられる。このような細部への注意は、懐石料理の体験のすべての面が調和し、意図的に感じられることを保証する。
        </p>
        <div class="image-container">
          <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/A%20Culinary%20Journey%20into%20Japan%E2%80%99s%20Kaiseki:%20The%20Art%20of%20Fine%20Dining/3.png"
            alt="Structure of Kaiseki Meal"
          />
        </div>
        <h3 class="section-title">懐石料理の構成</h3>
        <p class="section-text">
          伝統的な懐石料理には、料理の物語で特定の役割を持つ以下のコースが含まれる：
          <br /><br />
          <strong>先付（さきづけ）</strong> – 食事のトーンを設定する前菜。<br />
          <strong>吸物（すいもの）</strong> – 繊細な季節の味を強調する清湯。<br />
          <strong>向付（むこうづけ）</strong> – 刺身、しばしば季節の最も新鮮な魚。<br />
          <strong>焼物（やきもの）</strong> – シーフードやプレミアム和牛を特徴とする焼き料理。<br />
          <strong>煮物（にもの）</strong> – うま味に富み、温かく提供される煮物。<br />
          <strong>八寸（はっすん）</strong> – 季節の食材を代表する小さな盛り合わせ。<br />
          <strong>食事（しょくじ）</strong> – ご飯、漬物、味噌汁で食事を締めくくる。<br />
          <strong>水物（みずもの）</strong> – 爽やかなデザート、しばしば果物や軽いコンフィチュールを特徴とする。<br />
          各コースは慎重にタイミングが決められ、シェフの専門知識が流れを指示して、シームレスで記憶に残る体験を創り出す。
        </p>
        <div class="image-container">
          <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/A%20Culinary%20Journey%20into%20Japan%E2%80%99s%20Kaiseki:%20The%20Art%20of%20Fine%20Dining/4.png"
            alt="Where to Experience Kaiseki"
          />
        </div>
        <h3 class="section-title">日本で懐石料理を体験する場所</h3>
        <p class="section-text">
          日本の文化の中心地である京都は、懐石料理の発祥地であり、その本物さを体験するのに最適な目的地である。京都の伝統的な料亭（高級日本料理店）や旅館（高級宿）では、静かな庭園や畳敷きのダイニングルームの眺めを楽しみながら懐石料理を提供している。京都以外では、東京や大阪などの都市でもミシュラン星付きの施設で懐石料理を提供しており、伝統的な技法と現代的な革新を融合させている。よりカジュアルな入門として、一部のレストランでは「ミニ懐石」オプションを提供しており、より手頃な価格でそのスタイルの味を提供する。
        </p>
        <div class="image-container">
          <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/A%20Culinary%20Journey%20into%20Japan%E2%80%99s%20Kaiseki:%20The%20Art%20of%20Fine%20Dining/5.png"
            alt="Unforgettable Kaiseki"
          />
        </div>
        <h3 class="section-title">忘れられない日本の味</h3>
        <p class="section-text">
          懐石料理は単なる食事以上のもの - 日本の料理の遺産と文化哲学への没入である。季節の食材からエレガントなプレゼンテーションまで、懐石料理のすべての面は、日本の自然への敬意と上品な食事の芸術性を反映している。経験豊富な美食家であろうと、好奇心旺盛な旅行者であろうと、日本を訪れた際には懐石料理を体験することが必須である。それは、一皿一皿、国の魂とつながるおいしい方法である。
        </p>
      </div>
    </div>
      `,
  },
  {
    id: 32,
    title: "マハ·クンブ·メラ2025：スピリチュアルとカルチャーの冒険ガイド",
    urlinform: "MahaKumbhMela2025YourGuidetoaSpiritualandCulturalAdventure",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Maha%20Kumbh%20Mela%202025%20Your%20Guide%20to%20a%20Spiritual%20and%20Cultural%20Adventure/Maha%20Kumbh%20Mela1.webp",
    ],
    tags: ["インド", "フェスティバル", "宗教", "信仰", "活動", "祝う"],
    description:
      "マハ·クンブ·メラ2025は、インドで最も究極のスピリチュアルとカルチャーのイベントで、ガンガ川、ヤムナ川、サラスワティ川が合流するプライヤーグラージュに数百万の巡礼者、旅行者、好奇心旺盛な人々を引き寄せる。",
    category: "ガイド",
    nation: "インドネシア",
    body: `
          <div class="container">
      <div class="content">
        <div class="header">
          <h1>
            マハ·クンブ·メラ2025：スピリチュアルとカルチャーの冒険ガイド
          </h1>
          <p class="description">
            マハ·クンブ·メラ2025は、インドで最も究極のスピリチュアルとカルチャーのイベントで、ガンガ川、ヤムナ川、サラスワティ川が合流するプライヤーグラージュに数百万の巡礼者、旅行者、好奇心旺盛な人々を引き寄せる。12年ごとに開催されるこの一生に一度の体験は、古代の儀式を目撃し、スピリチュアルリーダーとつながり、信仰と伝統の活気に満ちた雰囲気に浸るチャンスを提供する。ここでは、到着方法と到着後に何をするかについて知っておくべきすべてのことを紹介する。
          </p>
        </div>
        <div class="image-container">
          <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Maha%20Kumbh%20Mela%202025%20Your%20Guide%20to%20a%20Spiritual%20and%20Cultural%20Adventure/1.png"
            alt="Getting to Maha Kumbh Mela"
          />
        </div>
        <h3 class="section-title">マハ·クンブ·メラへの行き方</h3>
        <p class="section-text">
          マハ·クンブ·メラへの旅行は冒険の一部！以下に旅程の計画方法を紹介する：
          <br /><br />
          <strong>飛行機で：</strong>最も近い空港はプライヤーグラージュのバムラウリ空港（IXD）で、デリー、ムンバイ、コルカタなどの主要都市からのフライトがある。国際線を利用する場合は、ヴァラナシやラクナウの空港に到着することができ、プライヤーグラージュから車で数時間の距離にある。そこから、列車に乗るかタクシーを雇ってフェスティバル会場に到着する。<br /><br />
          <strong>列車で：</strong>プライヤーグラージュ·ジャンクションはインドで最も忙しい鉄道駅の一つで、全国各地の都市と良好に接続されている。クンブの間、大量の訪問者を収容するために特別列車が運行される。迷惑のない旅程を確保するために事前にチケットを予約する。<br /><br />
          <strong>道路で：</strong>プライヤーグラージュはウッタル·プラデーシュ州と隣接州の主要都市から道路でアクセス可能。州交通バス、プライベートタクシー、ライドシェアサービスが頻繁に運行されている。フェスティバル会場近くの交通渋滞が予想されるため、計画的に対応する。
          <br /><br />
          <strong>現地交通：</strong>プライヤーグラージュに到着したら、オートリクシャ、イーリクシャ、シャトルバスを利用して市内を移動し、クンブ·メラ会場に到着する。多くの道路はピークタイムに歩行者専用になるため、快適な歩きやすい靴が必須。
        </p>
        <div class="image-container">
          <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Maha%20Kumbh%20Mela%202025%20Your%20Guide%20to%20a%20Spiritual%20and%20Cultural%20Adventure/2.png"
            alt="Activities at Maha Kumbh Mela"
          />
        </div>
        <h3 class="section-title">マハ·クンブ·メラの活動</h3>
        <p class="section-text">
          マハ·クンブ·メラは感覚の饗宴で、スピリチュアルとカルチャーの本質に没入するための数え切れないほどの体験を提供する。ここでは見逃すべきではないもの：
          <br /><br />
          <strong>サンガムで聖なる入水をする：</strong>クンブ·メラのハイライトは、ガンガ川、ヤムナ川、サラスワティ川が合流するサンガムでの聖なる入水。罪を洗い、救いをもたらすと信じられるこの儀式は、最も重要な入水日で最も意味深いため、日程を確認し計画的に参加する。<br /><br />
          <strong>スピリチュアルセレモニーに参加する：</strong>日の出や日没時に川岸で魅惑的なアールティ（祈祷儀式）に参加する。これらのセレモニーは、リズミカルな唱えと輝くランプで、インドのスピリチュアルな心とつながる忘れられない体験である。<br /><br />
          <strong>アカーラを探索する：</strong>アカーラは、さまざまな聖人や禁欲者の教派によって設立されたキャンプで、それぞれが独自の伝統と哲学を持っている。これらのスピリチュアルリーダーと交流し、彼らの実践について学び、インドのスピリチュアルに関する洞察を得る。
          <br /><br />
          <strong>カルチャーパフォーマンスに浸る：</strong>クンブ·メラはカルチャーの祝宴でもある。インドの多様な遺産を反映したフォークミュージック、ダンス、アート展覧会を楽しむ。パフォーマンスはフェスティバル会場全体の屋外会場で行われる。<br /><br />
          <strong>地元の食べ物を味わう：</strong>コミュニティキッチンや屋台でシンプルでおいしいベジタリアンの食事を味わう。人気の料理にはプーリサブジ、ジャレビ、チャイがある。独特な体験のために、サードゥスや巡礼者によって準備された食事を試す。<br /><br />
          <strong>ヨガと瞑想を実践する：</strong>経験豊富なグルが率いるヨガと瞑想セッションで心と体を活性化させる。クンブの静かな雰囲気は、自己反省と内面の平和のための完璧な設定である。<br /><br />
          <strong>フェスティバルの精神を捉える：</strong>流れている僧侶の鮮やかな服装から川辺の緻密な儀式まで、マハ·クンブ·メラは写真家のパラダイス。イベントの魔法を捉える際には参加者のプライバシーを尊重する。
        </p>
        <div class="image-container">
          <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Maha%20Kumbh%20Mela%202025%20Your%20Guide%20to%20a%20Spiritual%20and%20Cultural%20Adventure/3.png"
            alt="Tips for Maha Kumbh Mela"
          />
        </div>
        <h3 class="section-title">忘れられない体験のためのヒント</h3>
        <p class="section-text">
          <strong>早めに予約する：</strong>ホテル、アシュラム、またはフェスティバルのために設立された一時的なテントシティなど、事前に宿泊施設を確保する。<br /><br />
          <strong>快適に過ごす：</strong>軽く荷物をまとめるが、暖かい服装、リユーザブル水ボトル、日焼け止め、応急キットなどの必需品を含める。<br /><br />
          <strong>忍耐強くいる：</strong>特に主要な入水日には混雑が予想される。冷静にいて、フェスティバル主催者の指示に従う。<br /><br />
          <strong>地元の習慣を尊重する：</strong>観察されている伝統や儀式に注意を払う。イベントの精神を完全に受け入れるために、控えめな服装で敬意を持って行動する。
        </p>
        <div class="image-container">
          <img
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Maha%20Kumbh%20Mela%202025%20Your%20Guide%20to%20a%20Spiritual%20and%20Cultural%20Adventure/4.png"
            alt="Unforgettable Kumbh Mela"
          />
        </div>
        <h3 class="section-title">忘れられない体験</h3>
        <p class="section-text">
          マハ·クンブ·メラ2025は、単なるイベントではない - それはカルチャーとスピリチュアルの境界を超えた深い体験である。神の祝福を求めたり、カルチャーの充実を求めたり、単なる忘れられない冒険を求めたりするにしても、この壮大なフェスティバルは誰にでも何かを提供する。インスピレーションを受け、謙虚になり、インドの本質と深くつながる旅の準備をする。
        </p>
      </div>
    </div>
      `,
  },

  {
    id: 33,
    title: "ウダイプールで完璧なホテルを選ぶ究極のガイド (2025)",
    urlinform: "UltimateGuidetoChoosingthePerfectHotelinUdaipur2025",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Ultimate%20Guide%20to%20Choosing%20the%20Perfect%20Hotel%20in%20Udaipur%20(2025)/Udaipur%20Hotel1.webp",
    ],
    tags: ["インド", "旅行", "ホテル", "旅行のヒント", "目的地", "視点"],
    description:
      "ウダイプール、通称「湖の街」は、インドで最も魅力的な旅行目的地の一つ。王家の遺産、驚くべき宮殿、息をのむような湖の景色で知られるこの街は、歴史、贅沢、静けさを求める旅行者の夢の地。",
    category: "ホテル",
    nation: "インドネシア",
    body: `
         <div class="container">
      <div class="content">
        <div class="header">
          <h1>ウダイプールで完璧なホテルを選ぶ究極のガイド (2025)</h1>
        <div class="image-container">
          <img 
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Ultimate%20Guide%20to%20Choosing%20the%20Perfect%20Hotel%20in%20Udaipur%20(2025)/1.png" 
            alt="Introduction to Udaipur Hotels"
           />
        </div>
          <p class="description">
            ウダイプール、通称「湖の街」は、インドで最も魅力的な旅行目的地の一つ。王家の遺産、驚くべき宮殿、息をのむような湖の景色で知られるこの街は、歴史、贅沢、静けさを求める旅行者の夢の地。
            旅行で最も重要な要素の一つは、適切な宿泊施設を選ぶこと。壮大な遺産の宮殿から居心地の良いブティックホテルまで、数え切れないほどのホテルがあるウダイプールでの宿泊先選びは、圧倒されることがある。この2025年の究極のガイドは、旅行スタイル、予算、期待に基づいて完璧なホテルを選ぶのに役立つ。
          </p>
        </div>
        <div class="image-container">
          <img 
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Ultimate%20Guide%20to%20Choosing%20the%20Perfect%20Hotel%20in%20Udaipur%20(2025)/2.png" 
            alt="Guide to Hotels in Udaipur"
           />
        </div>
        <h3 class="section-title">ウダイプールで最高のホテルを選ぶ方法</h3>
        <p class="section-text">
          適切な宿泊施設を見つけることは、贅沢だけでなく、場所、体験、予算に関すること。2025年のウダイプール旅行で最適な滞在先を絞り込む方法は以下の通り。
          <br><br>
          <strong>望む体験を決める：</strong>ウダイプールは、贅沢な宮殿ホテル、ブティック遺産ホテル、予算に優しいホステル、湖畔のリトリートなど、さまざまな滞在先を提供している。
        </p>
        <div class="image-container">
          <img 
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Ultimate%20Guide%20to%20Choosing%20the%20Perfect%20Hotel%20in%20Udaipur%20(2025)/3.png" 
            alt="Luxury Hotels in Udaipur"
           />
        </div>
        <h3 class="section-title">ウダイプールの最高のホテル (2025) – すべての旅行者に手厳選</h3>
        <p class="section-text">
          <strong>A. 贅沢 & 遺産ホテル (1泊25,000ルピー以上)</strong>
          <br>- タジ·レイク·パレス – ピチョラ湖に浮かぶ宮殿で、比類のない贅沢な体験を提供。
          <br>- オベロイ·ウダイビラス – 世界で有名なホテルで、素晴らしい建築、プライベートプール、湖の景色を提供。
          <br>- RAASデヴィガル – 歴史と現代的な快適さを融合した要塞転換の贅沢ホテル。
          <br><br>
          <strong>B. 中級ブティックホテル (1泊7,000 – 25,000ルピー)</strong>
          <br>- ジャガット·ニワス·パレス – 遺産の建築と屋上レストランを備えた湖畔ホテル。
          <br>- ファテ·ガル – 山頂の景色と遺産スタイルのおもてなしを提供する修復された宮殿。
          <br>- マドリ·ハヴェリ – 素晴らしい雰囲気と屋上ダイニングを備えた予算に優しいハヴェリ。
          <br><br>
          <strong>C. 予算ホテル & ホステル (1泊1,500 – 7,000ルピー)</strong>
          <br>- バンジャラ·ホステル – 素晴らしい街の景色を備えたトレンディなバックパッカーホステル。
          <br>- ゾステル·ウダイプール – ソロ旅行者に人気で、ドミトリーとプライベートルームを提供。
          <br>- マスタッシュ·ウダイプール – 社交イベントと屋上ダイニングを備えたシックな予算ホステル。
        </p>
        <div class="image-container">
          <img 
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Ultimate%20Guide%20to%20Choosing%20the%20Perfect%20Hotel%20in%20Udaipur%20(2025)/4.png" 
            alt="Budget Hotels in Udaipur"
          />
        </div>
        <h3 class="section-title">ウダイプールで適切な宿泊施設を選ぶ5つの専門家のヒント</h3>
        <p class="section-text">
          <strong>1. 旅程に基づいて適切な場所を選ぶ：</strong>ピチョラ湖近くに滞在することは初めての訪問者に最適で、ファテ·サガル湖はより静かな滞在を提供。
          <br><br>
          <strong>2. レビューと評価を確認する：</strong>検証済みの旅行者のレビューを探し、誤解を招く情報を避ける。
          <br><br>
          <strong>3. 価格を比較し、事前に予約する：</strong>繁忙期には早期予約が必要で、オフシーズンには大きな割引が提供されることがある。
          <br><br>
          <strong>4. ユニークなアメニティを探す：</strong>プライベートバルコニー、インフィニティプール、スパサービスは滞在を向上させることができる。
          <br><br>
          <strong>5. 輸送手段とアクセシビリティを考慮する：</strong>旧市街のホテルには直接車でのアクセスがない場合があるため、短い歩行に備える。
        </p>
        <div class="image-container">
          <img 
            src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Ultimate%20Guide%20to%20Choosing%20the%20Perfect%20Hotel%20in%20Udaipur%20(2025)/5.png" 
            alt="Tips for Choosing Hotels in Udaipur"
           />
        </div>
        <h3 class="section-title">ウダイプールでどこに滞在しますか？</h3>
        <p class="section-text">
          ウダイプールの魅力は、その驚くべきアトラクションだけでなく、忘れられない滞在体験にもある。宮殿ホテルで王族のように暮らす夢を見るか、湖の景色で目覚めるか、居心地の良いブティック滞在を楽しむかに関わらず、ウダイプールはすべての旅行者に完璧な宿泊施設を提供している。
          <br><br>
          事前に計画し、賢く選び、2025年にウダイプールの魔法を体験する準備をしよう！
        </p>
      </div>
    </div>
      `,
  },
  {
    id: 34,
    title:
      "日本のショッピングについて知っておくべき最高のこと – スマートに買い物をして、もっと節約しよう！",
    urlinform: "TheBestThingYouShouldKnowAboutJapansShoppingShopSmartSaveMore",
    css: `${detailPageCss2}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/The%20Best%20Thing%20You%20Should%20Know%20About%20Japan%E2%80%99s%20Shopping%20%E2%80%93%20Shop%20Smart%20&%20Save%20More!/Japan%E2%80%99s%20Shopping1.webp",
    ],
    tags: ["日本", "旅行", "ショッピング", "税金免除", "購入", "祝う"],
    description:
      "観光客にとって最大の特典の一つは、日本の税金免除ショッピング政策で、消費税（VAT）の払い戻しを受けることでお金を節約できる。",
    category: "ガイド",
    nation: "日本",
    body: `
        <div class="container">
      <div class="content">
        <div class="header">
          <h1>日本のショッピングについて知っておくべき最高のこと – スマートに買い物をして、もっと節約しよう！</h1>
          <p class="description">
            日本は、ハイテクガジェットから伝統的なお土産まで、旅行者にとってショッピングのパラダイス。 
            観光客にとって最大の特典の一つは、日本の税金免除ショッピング政策で、消費税（VAT）の払い戻しを受けることでお金を節約できる。この税金免除政策は、日本でのショッピングをさらに魅力的にするが、特定の規則と条件が付いている。このガイドは、日本の税金免除政策について知っておくべきすべてのことを説明する。
          </p>
          <div class="image-container">
            <img src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/The%20Best%20Thing%20You%20Should%20Know%20About%20Japan%E2%80%99s%20Shopping%20%E2%80%93%20Shop%20Smart%20&%20Save%20More!/1.png"
                 alt="Shopping in Japan"
             />
          </div>
        </div>
        <h3 class="section-title">日本の税金免除政策を理解する</h3>
        <p class="section-text">
          日本では、ほとんどの商品に10％の消費税が課されており、これは小売価格に含まれている。 
          しかし、短期滞在者であれば、日本の税金免除ショッピングプログラムを利用して、参加店舗でこの税金の払い戻しを受けることができる。
        </p>
        <div class="image-container">
          <img src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/The%20Best%20Thing%20You%20Should%20Know%20About%20Japan%E2%80%99s%20Shopping%20%E2%80%93%20Shop%20Smart%20&%20Save%20More!/2.png"
               alt="Japan's Tax-Free Policy"
           />
        </div>
        <h3 class="section-title">税金免除ショッピングの対象となる商品は？</h3>
        <p class="section-text">
          日本での税金免除ショッピングは、主に2つの商品カテゴリーに適用される：
          <br><br>
          <strong>1. 一般商品</strong>
          <br>これらは消耗品ではなく、長期的に使用できる商品。例：
          <br>- 電子機器 & ガジェット（カメラ、ノートパソコン、ヘッドフォンなど）
          <br>- ファッション & アクセサリー（衣類、靴、バッグ、時計など）
          <br>- ホームウェア & お土産（伝統的な工芸品、陶器、文房具など）
          <br>- 贅沢品（ジュエリー、ブランド商品など）
          <br>税金免除の対象となるには、参加店舗での1回の取引で少なくとも5,000円分の商品を購入する必要がある。一般商品の購入には上限はない。
          <br><br>
          <strong>2. 消耗品</strong>
          <br>消耗品は、短期間で使用される商品。例：
          <br>- 化粧品 & スキンケア
          <br>- 食品 & スナック
          <br>- 飲料（アルコール、茶などを含む）
          <br>- 薬 & サプリメント
          <br>消耗品が税金免除ショッピングの対象となるには、1回の取引で5,000円から500,000円の範囲内で購入する必要がある。さらに、これらの商品は特別な税金免除パッケージに密封され、日本を離れるまで開封してはいけない。
          <br><br>
        </p>
        <div class="gallery">
          <img src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/The%20Best%20Thing%20You%20Should%20Know%20About%20Japan%E2%80%99s%20Shopping%20%E2%80%93%20Shop%20Smart%20&%20Save%20More!/3.png"
               alt="Eligible Tax-Free Items"
           />
          <img src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/The%20Best%20Thing%20You%20Should%20Know%20About%20Japan%E2%80%99s%20Shopping%20%E2%80%93%20Shop%20Smart%20&%20Save%20More!/4.png"
               alt="Excluded Tax-Free Items"
           />
        </div>
        <h3 class="section-title">税金免除の特典を受ける方法は？</h3>
        <p class="section-text">
          税金免除の節約を受ける手順：
          <br><strong>ステップ1：</strong>「税金免除」ロゴを表示している店舗で買い物をする。
          <br><strong>ステップ2：</strong>レジでパスポートを提示する。
          <br><strong>ステップ3：</strong>税金免除のレシートを受け取り、パスポートと一緒に保管する。
          <br><strong>ステップ4：</strong>消耗品は元の包装で密封されたままにする。
          <br><strong>ステップ5：</strong>出発前に空港で購入品とレシートを提示する。
        </p>
        <div class="image-container">
        <img 
          src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/The%20Best%20Thing%20You%20Should%20Know%20About%20Japan%E2%80%99s%20Shopping%20%E2%80%93%20Shop%20Smart%20&%20Save%20More!/5.png"
          alt="How to Redeem Tax-Free Benefits"
        />
        </div>
        <h3 class="section-title">日本での税金免除ショッピングの追加のヒント</h3>
        <p class="section-text">
          - 大額の購入にはクレジットカードを使用する。
          <br>- 払い戻し方法を事前に確認する。
          <br>- 主要なモールやデパートで買い物をする。
          <br>- 購入前に店舗固有のポリシーについて常に確認する。
          <br>- 税金免除の要件を満たすために購入を組み合わせる。
        </p>
        <div class="image-container">
        <img 
          src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/The%20Best%20Thing%20You%20Should%20Know%20About%20Japan%E2%80%99s%20Shopping%20%E2%80%93%20Shop%20Smart%20&%20Save%20More!/6.png"
          alt="Shopping Savings in Japan"
        />
        </div>
        <h3 class="section-title">日本の税金免除ショッピングを始めて、もっと節約しよう！</h3>
        <p class="section-text">
          日本の税金免除ショッピング政策は、素晴らしいショッピング体験を楽しみながらお金を節約する素晴らしい方法。 
          電子機器、ファッション、伝統的なお土産を探しているかに関わらず、このガイドはショッピング旅行を最大限に活用するのに役立つ。 
          次回日本を訪れるときは、税金免除ショッピングで節約を最大化しよう！
        </p>
        <p class="footer-text">
          日本での税金免除ショッピングを体験したことがありますか？ ない場合は、今すぐ体験に来てください！
        </p>
      </div>
    </div>
      `,
  },

  {
    id: 35,
    title: "ユニバーサル·スタジオ·シンガポール：必見の観光地！",
    urlinform: "UniversalStudiosSingaporeAMust-VisitDestination",
    css: `${detailPageCss1}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Universal%20Studios%20Singapore:%20A%20Must-Visit%20Destination!/universal-studios.webp",
    ],
    tags: ["シンガポール", "旅行", "USS", "テーマパーク", "ミニオン", "アジア"],
    description:
      "テーマパークやスリル満点のアトラクションが好きなら、ユニバーサル·スタジオ·シンガポール（USS）は旅行リストのトップに入れるべき！セントーサ島に位置するUSSは、アジアで最も人気のあるテーマパークの一つで、没入型のハリウッドテーマ体験で毎年何百万人もの訪問者を引き付けている。",
    category: "旅行",
    nation: "シンガポール",
    body: `
       <div class="container">
      <div class="content">
        <div class="header">
          <h1>ユニバーサル·スタジオ·シンガポール：必見の観光地！</h1>
          <p class="description">
            テーマパークやスリル満点のアトラクションが好きなら、ユニバーサル·スタジオ·シンガポール（USS）は旅行リストのトップに入れるべき！セントーサ島に位置するUSSは、アジアで最も人気のあるテーマパークの一つで、没入型のハリウッドテーマ体験で毎年何百万人もの訪問者を引き付けている。そして今、さらに新たな楽しみがあなたにやってくる——ミニオンランド·シンガポールが間もなくオープンし、USSに新たな楽しみのレベルをもたらす！
          </p>
          <div class="image-container">
            <img src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Universal%20Studios%20Singapore:%20A%20Must-Visit%20Destination!/1.png" alt="Universal Studios Singapore Entrance" />
          </div>
        </div>
        <h3 class="section-title">ユニバーサル·スタジオ·シンガポールで期待できること</h3>
        <div class="image-container">
          <img src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Universal%20Studios%20Singapore:%20A%20Must-Visit%20Destination!/2.png" alt="Thrilling Rides at USS" />
        </div>
        <p class="section-text">
          USSは7つのテーマゾーンを提供し、各ゾーンにはブロックバスター映画に基づいたスリル満点の乗り物、ライブエンターテインメント、ダイニング体験が用意されている。必見のアトラクションには以下が含まれる：
          <br>- <strong>トランスフォーマー：ザ·ライド 3D</strong> – デセプティコンとの衝撃的な戦い。
          <br>- <strong>ジュラシック·パーク ラピッド·アドベンチャー</strong> – 史前の地を巡る刺激的なウォーターライド。
          <br>- <strong>バトルスター·ギャラクティカ：ヒューマン vs. サイロン</strong> – 世界最高のデュエルローラーコースター！
          <br>- <strong>ムミーの復讐</strong> – 完全な暗闇の中を高速で走る屋内ローラーコースター。
        </p>
        <h3 class="section-title">新アトラクション：ミニオンランド·シンガポール</h3>
        <div class="image-container">
          <img src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Universal%20Studios%20Singapore:%20A%20Must-Visit%20Destination!/3.png" alt="Minion Land at USS" />
        </div>
        <p class="section-text">
          ミニオンランドの登場に備えよう、USSに新たに加わるこのエキサイティングなゾーンは、デスピカブル·ミーから愛らしい黄色いミニオンたちを生き生きと蘇らせる！
          <br>家族向けの乗り物、テーマのあるダイニング、そして子供から大人まで楽しめる陽気なミニオンの騒動が期待できる。USSはまだすべての詳細を明かしていないが、ミニオンランドは世界中のユニバーサルテーマパークと同様の没入型体験を特徴とするだろう、アニメーション愛好家にとっては必見の場所となる！
        </p>
        <h3 class="section-title">ユニバーサル·スタジオ·シンガポールへの行き方</h3>
        <div class="image-container">
          <img src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Universal%20Studios%20Singapore:%20A%20Must-Visit%20Destination!/4.png" alt="Getting to Universal Studios Singapore" />
        </div>
        <p class="section-text">
          USSはセントーサ島に位置し、以下の方法で簡単にアクセスできる：
          <br>- <strong>MRT：</strong>北東線または環状線でハーバーフロント駅まで行く。そこからビボシティ3階へ行き、セントーサエクスプレスでウォーターフロント駅まで行く。
          <br>- <strong>バス：</strong>セントーサバスサービスやシンガポール各地からの直通バスに乗る。
          <br>- <strong>タクシー/Grab：</strong>入口まで直接連れて行ってくれる便利なオプション。
          <br>- <strong>歩いて：</strong>ビボシティから景色の良いセントーサボードウォークを歩いてパークまで行く。
        </p>
        <h3 class="section-title">USSチケットの購入場所</h3>
        <p class="section-text">
          - <strong>公式USSウェブサイト</strong> – リゾートワールド·セントーサのウェブサイトから直接チケットを購入。
          <br>- <strong>認定リセラー</strong> – KlookやKKdayなどの信頼できるプラットフォームは、しばしば割引やバンドルディールを提供。
          <br>- <strong>現地購入</strong> – 入口でチケットを購入できるが、長い列を避けるためにオンラインでの購入が推奨される。
        </p>
        <h3 class="section-title">USS内で必見のアイコン的施設</h3>
        <div class="image-container">
          <img src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Universal%20Studios%20Singapore:%20A%20Must-Visit%20Destination!/5.png" alt="Iconic Facilities at USS" />
        </div>
        <p class="section-text">
          - <strong>ハリウッド·ブールバード：</strong>華やかにパークに入場、写真撮影に最適！
          <br>- <strong>ファーファーアウェイ城：</strong>シュレック4Dアドベンチャーの舞台で、メルヘンチックな雰囲気。
          <br>- <strong>サイファイ·シティ：</strong>トランスフォーマーやバトルスター·ギャラクティカなどのアクション満点の乗り物がある未来都市ゾーン。
          <br>- <strong>ニューヨークゾーン：</strong>映画セットを散策し、スティーヴン·スピルバーグのライツ、カメラ、アクション！ショーを楽しむ。
        </p>
        <h3 class="section-title">ミニオン満載の冒険に備えよう！</h3>
        <p class="section-text">
          ミニオンランドが間もなく登場することで、ユニバーサル·スタジオ·シンガポールはさらにエキサイティングになる！スリルを求める人、映画ファン、家族で楽しみたい人、USSは誰にでも何かしらの楽しみを提供している。旅行の計画を立て、事前にチケットを購入し、シンガポールの最高のテーマパークの一つで忘れられない冒険に出発しよう！
        </p>
      </div>
    </div>
      `,
  },
  {
    id: 36,
    title: "2025年注目の中国の新興観光地：次に訪れるべき場所",
    urlinform: "EmergingChineseDestinationsfor2025WheretoVisitNext",
    css: `${detailPageCss1}${detailPageCss3}`,
    images: [
      "https://storage.googleapis.com/apm-creative/h5/exploreAsia/Emerging%20Chinese%20Destinations%20for%202025%3A%20Where%20to%20Visit%20Next/emerging-chinese.webp",
    ],
    tags: ["中国", "旅行", "ランドマーク", "山城", "張家界", "桂林漓江"],
    description:
      "旅行者が新鮮でユニークな体験を求める中、中国のあまり探索されていないが息をのむような美しさの観光地が人気を集めている。",
    category: "ガイド",
    nation: "中國",
    body: `
       <div class="container">
      <div class="content">
        <div class="header">
          <h1>2025年注目の中国の新興観光地：次に訪れるべき場所</h1>
          <p class="description">
            旅行者が新鮮でユニークな体験を求める中、中国のあまり探索されていないが息をのむような美しさの観光地が人気を集めている。未来志向の都市から素晴らしい自然の不思議まで、2025年はこれらの新興の宝石を発見するのに最適な時期。アドベンチャーを求める人、文化を探索する人、自然を愛する人、重慶、張家界国家森林公園、桂林漓江などの観光地は必見だ。
          </p>
          <div class="image-container">
            <img src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Emerging%20Chinese%20Destinations%20for%202025%3A%20Where%20to%20Visit%20Next/1.png" alt="China Travel Destinations 2025" />
          </div>
        </div>
        <h3 class="section-title">重慶：山と光のメガシティ</h3>
        <div class="image-container">
          <img src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Emerging%20Chinese%20Destinations%20for%202025%3A%20Where%20to%20Visit%20Next/2.png" alt="Chongqing Cityscape" />
        </div>
        <p class="section-text">
          <strong>訪れる理由？</strong>中国の「山城」とあだ名される重慶は、近代的な超高層ビル、古代の歴史、ユニークな地元文化が融合したダイナミックな大都市。最近では息をのむような夜景、辛いホットポット、崖に建てられた都市景観で注目を集めている。
        </p>
        <h3 class="section-title">主要観光スポット：</h3>
        <p class="section-text">
          - <strong>洪崖洞：</strong>伝統的な建築と鮮やかなネオンライトが光る多階建ての複合施設で、写真撮影や地元のストリートフードに最適。<br>
          - <strong>李子坝駅：</strong>地下鉄がビルを通過する幻想的な光景で、インスタグラムで有名なスポット。<br>
          - <strong>武隆カルスト国立公園：</strong>ユネスコ世界遺産で、自然の石橋、峡谷、洞窟があり、トランスフォーマー：エイジ·オブ·エクスティンクションで特集されている。<br>
          - <strong>長江ロープウェイ：</strong>長江と市街地の空中景色を楽しめる。
        </p>
        <h3 class="section-title">張家界国家森林公園：夢のような景観</h3>
        <div class="image-container">
          <img src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Emerging%20Chinese%20Destinations%20for%202025%3A%20Where%20to%20Visit%20Next/3.png" alt="Zhangjiajie Mountains" />
        </div>
        <p class="section-text">
          <strong>訪れる理由？</strong>アバターの浮遊山をインスパイアしたことで有名な張家界国家森林公園は、高耸する砂岩柱、霧に包まれた山頂、緑豊かな谷が織りなす幻想的な不思議の国。
        </p>
        <h3 class="section-title">主要観光スポット：</h3>
        <p class="section-text">
          - <strong>アバター ハレルヤ山（元家界）：</strong>アバターに登場する浮遊島を思わせる象徴的な石柱。<br>
          - <strong>天子山：</strong>特に日の出時に公園全体の最高のパノラマビューを提供。<br>
          - <strong>百龍エレベーター：</strong>世界最高の屋外ガラスエレベーターで、崖壁を326メートル上昇。<br>
          - <strong>金鞭渓：</strong>緑豊かな景色とユニークな岩の形態が楽しめる風光明媚なハイキングコース。
        </p>
        <h3 class="section-title">桂林漓江クルーズ：自然の傑作を巡る旅</h3>
        <div class="image-container">
          <img src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Emerging%20Chinese%20Destinations%20for%202025%3A%20Where%20to%20Visit%20Next/4.png" alt="Guilin Li River Cruise" />
        </div>
        <p class="section-text">
          <strong>訪れる理由？</strong>桂林と陽朔を流れる漓江は、地球上で最も美しい景観の一つと称される。ここでの川クルーズは、壮大なカルスト山脈、古代の村、霧に包まれた水景を巡る。
        </p>
        <h3 class="section-title">主要観光スポット：</h3>
        <p class="section-text">
          - <strong>漓江クルーズ：</strong>桂林旅行のハイライトで、川に映える絵画のような石灰岩の峰々。<br>
          - <strong>陽朔田舎：</strong>風光明媚な山々と水田に囲まれたサイクリングや竹筏ラフティングのパラダイス。<br>
          - <strong>芦笛岩：</strong>多彩な鍾乳石と石筍が光る、魅惑的な洞窟で「自然美術の宮殿」として知られる。<br>
          - <strong>龍脊梯田：</strong>近くに位置するこの美しく彫刻された梯田は、中国の伝統的な農業生活の一瞥を提供。
        </p>
        <h3 class="section-title">最後の思い</h3>
        <p class="section-text">
          中国がその多様な景観と文化遺産を世界に示し続ける中、重慶、張家界、桂林などの新興観光地は世界中の旅行者の想像力を捉えている。重慶の未来都市の雰囲気、張家界の異世界の峰々、漓江の静かな水に引かれるかどうかに関わらず、2025年は中国の隠れた宝石を巡る忘れられない旅に出発するのに最適な年だ。
        </p>
        <div class="image-container">
          <img src="https://storage.googleapis.com/apm-creative/h5/exploreAsia/Emerging%20Chinese%20Destinations%20for%202025%3A%20Where%20to%20Visit%20Next/5.png" alt="China Travel Future" />
        </div>
        <p class="footer-text">
          今日から旅の計画を始めよう！
        </p>
      </div>
    </div>
      `,
  },
];
